import { Component, OnInit, ViewContainerRef, ElementRef, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { FormBuilder, FormGroup, Validators, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { CompositeArrayComponent } from 'src/modules/base/components/composite-array/composite-array.component';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BillingpopupComponent } from 'src/modules/billing/components/billingpopup/billingpopup.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import moment from 'proxies/dayjs';
import { Injector } from '@angular/core';
import { FormService } from 'src/modules/base/components/form/form.service';
import BaseDecorator from 'src/modules/base/base-decorator';
import { FieldGroup } from 'src/modules/base/components/form/models/field-group.model';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { PopUpOverGridWithControlsComponent } from 'src/modules/base/components/dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { PopupFormComponent } from 'src/modules/base/components/popupform/popupform.component';
import { CashDenominationComponent } from '../cash-denomination/cash-denomination.component';
import { QrCodeGeneratorComponent } from 'src/modules/base/components/qr-code-reader/qr-code-generator/qr-code-generator.component';
import PaymentModeFlagsDecorator from 'src/decorators/payment_mode_flags_decorator';

@Component({
    selector: 'app-payment-detail',
    templateUrl: './payment-detail.component.html',
    styleUrls: ['./payment-detail.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: PaymentDetailComponent,
            multi: true,
        }],
    standalone: false
})

export class PaymentDetailComponent extends BaseDecorator implements OnInit, OnDestroy {
  private smartModalService: SmartModalService;
  @Input() _value: any;
  @Input() config: any = {};
  dataSet: any;
  scheme_idd: any;
  deposit_arg: any;
  objval: any;
  value_data: any;
  @Input() optical_billing_advance:boolean=false;
  // screen-specific payment detail json (restricts payment modes by screen_name); defaults to the shared one
  @Input() paymentResource: string = 'payment_order_details';
  schm_rmvd: boolean = false;
  public form: FormGroup;
  addedAmount: any;
  public formService: FormService;
  self: any;
  rec_uhId: any;
  rec_employeeId: any;
  due_config: any;
   guarantor_config: any;
  sap_opt_config: any;
  rec_name: any;
  is_opt_sm_stage:boolean = false;
  show_sponsor:boolean = true;
  schemedatasource: any;
  recoveryData: any;
  discountchecked: boolean = true;
  @ViewChild('multiselectscheme') multiselectscheme: any;
  @Input() createDisable: boolean = false;
  @Input() bookDisable: boolean = false;
  draftDisable: boolean = false;
  openAccordian: boolean = true;
  blockMapping: FieldGroup[];
  critcality_Data:any;
  activeKey: any; override_config: boolean = false;
  isSponsorWorkFlowEnabledFlag: boolean = false;
  navVar: any = [{ field_name: "bill_summary", heading: "Billing Summary", block_id: "bill_summary", default_open: true, show: true },
  { field_name: "discount", heading: "Discount", block_id: "discount", default_open: false, show: true },
  { field_name: "income_details", heading: "Income Details", block_id: "income_details", default_open: true, show: false },
  { field_name: "upload_document", heading: "Upload Document", block_id: "upload_document", default_open: true, show: false },
  { field_name: "deposit", heading: "Deposit", block_id: "deposit", default_open: false, show: true },
    { field_name: "sponsor", heading: "Sponsor", block_id: "sponsor", default_open: false, show: (this.isSponsorWorkFlowEnabledFlag && this.appService.getApplication() == 'pharmacy')?true:false},
  { field_name: "advance", heading: "Advance", block_id: "advance", default_open: false, show: false },
  { field_name: "Sponsor_billing", heading: "Sponsor", block_id: "Sponsor_billing", default_open: false, show: this.showSponsorBlock() },
  { field_name: "payment_details", heading: "Payment Details", block_id: "payment_details", default_open: true, show: true },
  { field_name: "due", heading: "Due", block_id: "due", default_open: false, show: true },
  { field_name: "delivery_charges", heading: "Delivery Charges", block_id: "delivery_charges", default_open: false, show: true },
  { field_name: "remarks", heading: "Remarks", block_id: "remarks", default_open: false, show: true }
]
  is_advance_checked: boolean = false;
  is_discount_checked: boolean = false;
  scheme_selected: boolean = false; otp_id_due: any; otp_id_discount: any;
  patientInfo: any = {}
  book_config: any;
  @ViewChild('compositeArrayComponent') compositeArrayComponent: CompositeArrayComponent;
  // prefills in place; [dependentField] rebuilds the grid on every amount change
  paymentAmountPrefill = [{ dependent_field: 'net_receivable_amount', populate_field: 'received_amount' }];
  @ViewChild('compositeArrayComponentSponsor') compositeArrayComponentSponsor: CompositeArrayComponent;

  otp_visibility: boolean;
  time_for_otp_reset: boolean;
  is_previous_paid: any;
  question: any;
  otptimeout: any;
  visible_is_due: boolean;
  visible_is_checked: boolean = false;
  duplicatePaymentConfigResult: any;
  adding: number;
  update_fund=[];
  pos_transaction_id: any;
  payment_gateway_cancel_response: any;
  wkflow_called: boolean = false;
  payment_details_array: any;
  showPaymentdeails: boolean = true; //to show payment details
  showDeposit: boolean = true;//to show deposit
  approvalDocument: any;
  discountData: any; dueName: any; //discount data due data
  defaultsetting: any;
  configValueDecimal: string = "Yes";
  changeDueAmountDecimal: boolean = false;
  formObject: any;
  is_ovrride:boolean = true;
  remark_mandatory_config_value: any;
  discount_remark_mandatory_config_value: boolean;
  due_remark_mandatory_config_value: boolean;
  billing_reason_mandatory_config_value: boolean;
  disableEditBillButton: any;
  is_sponsor_fund_applied:  boolean = false;
  remarksMandatory: boolean = true;

    isAddedAdvance:boolean;
    firstTimeFilled:boolean;
  mainOBj: any;
  total_service_amount: number;
  total_edit_service_amount: number = 0;
  apiCheck: boolean = false;
  currentReciptNo: any;
  updatedReciptNoRequired: boolean = false;
  currentreciptamount: any;
  calledAction: string = "";
  scheme_type: any;
  totalGuaranteedAmount: any = 0;
  @Input()
  public set value(v: any) {
    if (v) {
      this._value = v;
    } else {
      this._value = '';
    }
  }
  @Input() public set orderdata(valueorder: any) {
    this.value_data = valueorder;
    // this.paymentForm.controls['is_discount'].setValue(true);
    //  this.amounts.is_discount=true;
    // this.paymentForm.controls['is_discount'].setValue(true);
    // this.paymentForm.controls['type'].setValue(valueorder.type);
    // this.paymentForm.controls['discount_on'].setValue(valueorder.discount_on);
    // this.paymentForm.controls['discount_type'].setValue(valueorder.discount_type);
    // this.paymentForm.controls['discount_value'].setValue(valueorder.discount_value);
    // this.paymentForm.controls['discount_authorized_by'].setValue(valueorder.authorized_by_id);
  }
  @Input() public set dataPay(value: any) {
    if (value && value.hasOwnProperty('hide_sections') && this.navVar.length > 0) {
      if(value.ovrride_hide)
      this.is_ovrride = false;
      for (let f of this.navVar) {
        if (f.block_id == 'discount' && value.hasOwnProperty('discount_component')) {
          f.show = value.discount_component;
        }
        if (f.block_id == 'deposit' && value.hasOwnProperty('deposite_component')) {
          f.show = value.deposite_component;
        }
        if (f.block_id == 'advance' && value.hasOwnProperty('advance_component')) {
          f.show = value.advance_component;
        }
        if (f.block_id == 'due' && value.hasOwnProperty('due_component')) {
          f.show = value.due_component;
        }
        if (f.block_id == 'remarks' && value.hasOwnProperty('remarks_component')) {
          f.show = value.remarks_component;
        }
        if (f.block_id == 'delivery_charges' && value.hasOwnProperty('charges_component')) {
          f.show = value.charges_component;
        }
        if (f.block_id == 'sponsor' && value.hasOwnProperty('sponsor_component') && this.isSponsorWorkFlowEnabledFlag) {
          f.show = value.sponsor_component;
        }
      }
    }
   if((this.dataSet?.transaction_type == "optical billing") || (value?.transaction_type == "optical billing"))
   {
    this.navVar.find(x => x.field_name == "deposit").show = false;
    this.showDeposit = false;
   }
    this.hideCharitySections();
    if (value && value.remark_mandatory_config_value) {
      this.discount_remark_mandatory_config_value = false;
      this.billing_reason_mandatory_config_value = false;
      value.remark_mandatory_config_value.find(e => {
        if (e?.id == 'op_bill_reason_type' && (value.transaction_type == 'OP Billing' || value.transaction_type == 'OP Edit Billing')) {
          this.billing_reason_mandatory_config_value = true;
        }
        if (e?.id == 'pharmacy_bill_reason_type' && value.transaction_type == 'Pharmacy Billing') {
          this.billing_reason_mandatory_config_value = true;
        }
        if (e.id == 'discount' && value.transaction_type != "optical billing" && (value.type === 'direct') ) {
          this.discount_remark_mandatory_config_value = true;  
        }
        if (e.id == 'optical_discount' && value.transaction_type == "optical billing" && (value.type === 'direct')) {
          this.discount_remark_mandatory_config_value = true;
        }
        if (e.id == 'due') {
          this.due_remark_mandatory_config_value = true;
        }
      });
    }
    if (value && value.not_disable == true) {
      this.createDisable = false;
    }
    if(value?.transaction_type && value.transaction_type == "Pharmacy Billing" && value.remarks){
      this.paymentForm.controls['remarks'].setValue(value.remarks);
    }
    if(value?.transaction_type && value.transaction_type == "Pharmacy Billing" && value.billing_reason){
      this.paymentForm?.controls?.['billing_reason']?.setValue(value.billing_reason);
    }
    this.setBillingReasonDatasource(value?.transaction_type);
    if (value && !value.not_disable) {

      if (value.err && (value.transaction_type == 'OP Billing' || value.transaction_type == 'OP Edit Billing' || value.transaction_type == 'IP Billing')) {
        this.createDisable = false;
        this.bookDisable = false;
        this.draftDisable = false;
        // IP/split IP billing sends a bare error stub when bill creation fails (e.g. invalid deposit);
        // keep the existing dataSet so total/net amounts are not patched to blank
        if (value.transaction_type != 'IP Billing')
          this.dataSet = value;
      }
      else {
        // a late op_amount re-push resets payment_detail below; snapshot rows to restore them
        const enteredRows = this.paymentForm.controls['payment_detail'].value;
        const enteredPaymentRows = Array.isArray(enteredRows) ? [...enteredRows] : [];
        // amounts those rows were entered against (form still holds the previous push here)
        const enteredNet = this.paymentForm.controls['net_receivable_amount'].value;
        const enteredTotals = this.paymentTotalsKey(this.paymentForm.controls['final_amount'].value, this.paymentForm.controls['authorised_amount'].value);
        // this.counter +=1;
        if (value.transaction_type != undefined) {
          if (value.transaction_type == 'OP Billing' || value.transaction_type == 'OP Edit Billing')
            this.deposit_arg = ',deposit_for:op_billing';
          else if (value.transaction_type == 'Ambulance Billing')
            this.deposit_arg = ',deposit_for:ambulance_billing';
          else if (value.transaction_type == 'Pharmacy Billing')
            this.deposit_arg = ',deposit_for:pharmacy_billing';
          // else if (value.transaction_type == 'optical billing')
          //   this.deposit_arg = ',admissionId:'+(value.orderId?value.orderId:'');
          else
            this.deposit_arg = "";
        }
        if (value.consumed_amount && value.is_previous_paid) {
          this.paymentForm.controls['consumed_amount'].setValue(value.consumed_amount);
          this.is_previous_paid = true
        }
        else {
          this.is_previous_paid = false
        }

        this.dataSet = value;
        console.log("this.dataset", this.dataSet)
        let payAmount = 0;

        this.patientInfo['uhId'] = value.uhId;
        this.patientInfo['patient_type'] = value.patient_type;
        this.patientInfo['gender'] = value.gender;
        if(value.patient_details && value.patient_details.uhId){
          this.patientInfo['uhId'] = value.patient_details.uhId
        }
        if(value.patient_details && value.patient_details.patient_type){
          this.patientInfo['patient_type'] = value.patient_details.patient_type
        }
        if(value.patient_details && value.patient_details.gender){
          this.patientInfo['gender'] = value.patient_details.gender
        }
        if (this.dataSet && this.dataSet.transaction_type == "Pharmacy Billing" && (this.dataSet.patient_type == "IP" || (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD PHARMACY SPLIT Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_PHARMACY_SPLIT_BILL_AUTH_CLEARANCE")))){
          this.patientInfo['uhId'] = value.op_amount_value.uhId;
        }
        if (value.checked && this.discountchecked) {// Update payment component from external resources

          this.amounts.is_discount = true;
          //this condition is made optical specific so that it does not affect other appliation this condition can be removed if there is a need to set discount
          if (this.paymentForm != undefined && this.paymentForm.controls != undefined && this.paymentForm.controls['is_discount'] != undefined && this.config != undefined && this.config.application != undefined && this.config.application == 'optical') {
            this.paymentForm.controls['is_discount'].setValue(true);
            if(this.dataSet && this.dataSet.transaction_type && this.dataSet.transaction_type == "optical billing")
            {
              if(value.discount_value && value.discount_value > 0)
              {
              this.paymentForm.controls['discount_authorized_by'].setValue(value.authorized_by_id != undefined ? value.authorized_by_id : value.discount_authorized_by_id != undefined ? value.discount_authorized_by_id : "");
              this.paymentForm.controls['discount_authorized_by_id'].setValue(value.authorized_by_id != undefined ? value.authorized_by_id : value.discount_authorized_by_id != undefined ? value.discount_authorized_by_id : "");
              }
            }
            else
            {
            this.paymentForm.controls['discount_authorized_by'].setValue(value.authorized_by_id != undefined ? value.authorized_by_id : value.discount_authorized_by_id != undefined ? value.discount_authorized_by_id : "");
            this.paymentForm.controls['discount_authorized_by_id'].setValue(value.authorized_by_id != undefined ? value.authorized_by_id : value.discount_authorized_by_id != undefined ? value.discount_authorized_by_id : "");
            }
            if (value.discount_on != undefined && value.discount_on == "service_item") {
              this.visibility.disableDiscountValue = true;
            }
            if(value.schemeId != this.paymentForm.controls['scheme'].value)
            this.schemeSetup(value);
          }
          this.visibility.disableField = false;
          this.paymentForm.patchValue(value);
          if (this.visibility.schemeVisible) {
            this.paymentForm.controls['type'].setValue('scheme');
          }
          else {
            this.paymentForm.controls['type'].setValue('direct');
          }
        }
        //for advance payment
        if ((value.advance_payment != undefined && value.advance_payment) || (value.previous_paid_details && this.dataSet.transaction_type == "optical billing")) {
          if(value.is_previous_paid && value.previous_paid_details)
          {
          this.paymentForm.patchValue({ is_default_amount: value.previous_paid_details.deposit_amount != undefined ? value.previous_paid_details.deposit_amount : null,used_advance_amount: value.previous_paid_details.consumed_amount != undefined ? value.previous_paid_details.consumed_amount : null, advance_payment: value.previous_paid_details.deposit_amount ? true : false});          }
        else
          this.paymentForm.patchValue({ is_default_amount: value.paid_amount != undefined ? value.paid_amount : null, advance_payment: value.paid_amount ? true : false});
          this.is_advance_checked = true;
          this.paymentForm.controls['is_default_amount'].disable();
          //this.paymentForm.controls['advance_payment'].disable();
          //this.checkAdvance()
          this.navVar.find(x => x.field_name == "advance").default_open = true;
        }

        if (value.patient_amount) {
          payAmount = value.patient_amount;
        } else {
          payAmount = value.net_amount - value.payer_amount;
        }
        let total_deposit_amount = 0
        if (this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['deposits'] && this.paymentForm.controls['is_used_deposit'] && this.paymentForm.controls['is_used_deposit'].value == true && this.paymentForm.controls['used_deposit_amount'].value == 0) {
          this.paymentForm.controls['deposits'].value.forEach(element => {
            total_deposit_amount += element.used_deposit_amount
          });
          this.paymentForm.controls['used_deposit_amount'].setValue(total_deposit_amount);
        }
        if (this.paymentForm.controls['is_sponsor_fund_applied'].value == true) {

          value.final_amount -= this.paymentForm.controls['used_deposit_amount'].value
          this.paymentForm.controls['net_receivable_amount'].setValue(value.final_amount);
          this.formService.blockMapping[1]['default_open'] = false;
          this.paymentForm.controls['is_discount'].setValue(false);
          this.visibility.discountFieldVisible = true;
          this.visibility.schemeVisible = false;
          this.paymentForm.controls['discount_on'].reset('');
          this.paymentForm.controls['discount_type'].reset('amount');
          this.paymentForm.controls['discount_reason'].reset('');
          this.paymentForm.controls['discount_authorized_by'].reset('');
          this.paymentForm.controls['discount_authorized_by_id'].reset('');
          this.paymentForm.controls['discount'].reset(0);
          value.discount = 0;
          this.paymentForm.controls['discount_value'].reset(0);
          this.paymentForm.controls['scheme'].reset('');
          this.paymentForm.controls['type'].setValue('direct');
          this.paymentForm.controls['discount_authorized_by_name'].reset('');
          this.paymentForm.controls['payment_detail'].reset([])
        }
        // rows in the grid lower net_receivable_amount, so it never matches final_amount; skip the reset when the
        // totals are unchanged (with no discount a reset re-prices via serviceDiscount, looping the price API)
        const rowsStillFit = this.paidToKeep(this.paymentForm.controls['payment_detail'].value) && this.paymentTotalsKey(value.final_amount, value.authorized_amount) == enteredTotals;
        if (!rowsStillFit && value.final_amount != this.paymentForm.controls['net_receivable_amount'].value && (value.type == undefined || value.type || value.type.index)) {
          this.resetAllData(value);
          this.showPaymentdeails = true;
          if ((this.dueName && (this.dueName.workflow_stage == "single_stage" || this.dueName.workflow_stage == "multi_stage") && this.paymentForm.controls['is_due'].value) || (this.discountData && (this.discountData.workflow_stage == "single_stage" || this.discountData.workflow_stage == "multi_stage") && (value && value.op_amount_value && value.op_amount_value.discount_value))) {
            this.showPaymentdeails = false;
          }
        }
        if(this.paymentForm.controls['is_due'].value && this.paymentForm.controls['due_amount'].value>0 && value.authorized_amount==this.paymentForm.controls['net_amount'].value){
          //this.paymentForm.controls['due_amount'].setValue(0);
          this.resetDueCheckbox();
          this.showPaymentdeails = true;
        }
        this.paymentForm.patchValue({ total_amount: value.amount, discount: value.discount, net_amount: value.net_amount, tax: value.tax, patient_amount: payAmount, net_receivable_payer_amount: value.payer_amount, authorised_amount: value.authorized_amount, net_receivable_amount: value.final_amount, final_amount: value.final_amount });
        if (value.type != undefined && (value.type == 'payerChange' || value.type == 'error' || value.type.index)) {
          this.resetAllData(value);
          this.showPaymentdeails = true;
        }
        this.bindDropDownsFormExternalResources(); //added for discount
        this.getDepositAmount();
        this.addedresourceInfo();
        //console.log("this.countr",this.counter)
        // OnPaymentAdd recomputes with a zero paid sum, so skip it over restored rows
        if (!this.restorePaymentRows(enteredPaymentRows, enteredNet, enteredTotals))
          this.OnPaymentAdd({ type: true });
      }
    }
    if(value && value.transaction_type!=undefined && value.transaction_type!="" && value.transaction_type == "OP Edit Billing"){
        this.disableEditBillButton = value.disabledUpdateBillButton;
    }
    // if(this.optical_billing_advance){
    //   this.getAdvanceAmount()
    // }
  };
  @Output() serviceDiscount = new EventEmitter<any>();
  @Output() billingSponsorFund = new EventEmitter<any>();
  @Output() deliveryCharges = new EventEmitter<any>();
  @Output() createBillButton = new EventEmitter<any>();
  @Output() authoriseDetail = new EventEmitter<any>();
  // bannerJson: any = false; //not in use
  payment_detail: any;
  dueApiSignature = {
    application: "facility-management",
    resource: "workflow_master_setup",
    query_id: "GET_DATA_OF_WORKFLOW",
    args: ""
  };
  discountApiSignature = {
    application: "facility-management",
    resource: "workflow_master_setup",
    query_id: "GET_DATA_OF_WORKFLOW",
    args: ""
  }
  patientCriticalityApi = {
         "application": "system-management",
        "resource": "valueset",
        "query_id": "get_valueset_by_id_flat",
        "args": "resourceId:color_coading_for_covid_bed,system:karexpert",
        "key": "id"
  }
  discountTypeApi = {
    "application": "system-management",
    "resource": "valueset",
    "query_id": "get_valueset_by_id_flat",
    "args": "resourceId:discount_type,system:karexpert",
  }
  reasonTypeDiscountApi = {
    "application": "facility-management",
    "resource": "facility_master",
    "query_id": "getReasonNameBasedOnReasonType",
    "args": "facility_master_type:REASON,reasontype_id:discount",
  }
  reasonTypeDueApi = {
    "application": "facility-management",
    "resource": "facility_master",
    "query_id": "getReasonNameBasedOnReasonType",
    "args": "facility_master_type:REASON,reasontype_id:due",
  }
  discTypeApiSignature = {
    application: "system-management",
    resource: "valueset",
    query_id: "get_valueset_by_id_flat",
    args: "resourceId:valueType,system:karexpert",
  }
  discOnApiSignature = {
    application: "system-management",
    resource: "valueset",
    query_id: "get_valueset_by_id_flat",
    args: "resourceId:discount_on,system:karexpert",
  }
  depositApi = {
    resource: "deposit_wallet",
    application: "payment",
    query_id: "GET_TOTAL_DEPOSIT_BY_UHID",
  }

  schemeApiSignature = {
    "application": "facility-management",
    "resource": "scheme_detail",
    "query_id": "GET_SCHEME_DETAILS"
  }
  paymentForm: FormGroup;
  amounts: any = {}
  responses: any = {}
  visibility: any = {}
  mainmulti = {
    datasource: {
      "application": "patient-registration",
      "resource": "patient",
      "query_id": "GET_EMPLOYEES_LIST",
      "args": "employee:Employee,noCount:1"
    },
    controls: {
      recovery: {
        value: ""
      }
    },
    question: {
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": false
      },
      getterKey: "id",
      format: "(item) => `${item.patient_name} || ${item.emp_no}`",
      getterValue: "patient_name",
      "req_keys": [
        "id",
        "patient_name",
        "emp_no",
        "name",
        "uhId"
      ],
      key: "recovery"
    },
    defaultsetting: {
      "singleSelection": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": true
    }
  }

  reasonmulti = {
    "datasource": {
      "application": "facility-management",
      "resource": "facility_master",
      "query_id": "getReasonNameBasedOnReasonType",
      "args": "facility_master_type:REASON,reasontype_id:due",
      "key": "id"
    },
    controls: {
      due_reason: {
        value: ""
      }
    },
    question: {
      "getterKey": "name",
      "getterValue": "name",
      "req_keys": ["name"]
    },
    defaultsetting: {
      "singleSelection": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": false
    }
  }
  remarkReasonTypeMulti = {
    "datasource": null,
    controls: {
      billing_reason: {
        value: ""
      }
    },
    question: {
      "getterKey": "name",
      "getterValue": "name",
      "req_keys": ["name"]
    },
    defaultsetting: {
      "singleSelection": true,
      "allowSearchFilter": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": false
    }
  }
  schemeresource: any;
  itemresource: any;
  discountmultireason = {
    "datasource": {
      "application": "facility-management",
      "resource": "facility_master",
      "query_id": "getReasonNameBasedOnReasonType",
      "args": "facility_master_type:REASON,reasontype_id:discount",
      "key": "id"
    },
    controls: {
      due_reason: {
        value: ""
      }
    },
    question: {
      "getterKey": "name",
      "getterValue": "name",
      "req_keys": ["name"]
    },
    defaultsetting: {
      "singleSelection": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": false
    }
  }
  sponsorQuestion = {
    "datasource": {
      "application": "facility-management",
      "resource": "sponsor_fund_master",
      "query_id": "GET_SPONSOR_NAME",
    },
    controls: {
      sponsor: {
        value: ""
      }
    },
    question: {
      "getterKey": "sponsor_name",
      "getterValue": "sponsor_name",
      "req_keys": ["all"]
    },
    defaultsetting: {
      "singleSelection": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": false
    }
  }
  constructor(public baseService: BaseService,
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoaderService,
    public utilService: UtilService,
    public injector: Injector,
    public containerRef?: ViewContainerRef,
    public alertService?: AlertsService,
    public appService?: AppService,
    public elementRef?: ElementRef,
    public rolePermissionService?: RolePermissionService,
    public preferenceService?: PreferenceService
    ) {
    super(activatedRoute, 'PaymentDetailComponent', injector);
    this.self = this;
    if (injector != undefined && injector.get != undefined) {
      this.smartModalService = injector.get(SmartModalService);
      this.formService = injector.get(FormService);
      this.baseService = injector.get(BaseService);
    }
    this.paymentForm = new FormGroup({
      'charity_validity_start_date': new FormControl(''),
      'charity_validity_end_date': new FormControl(''),
      'charity_given_by': new FormControl(''),
      // charity OP order income (same fields as charity_income_details.json on the admission request)
      'income_details': new FormGroup({
        'income_type': new FormControl(''),
        'income_source': new FormControl(''),
        'ration_card_issue_year': new FormControl(''),
        'income_certified_by': new FormControl(''),
        'tehsildar_income': new FormControl(''),
        'self_declared_income': new FormControl(''),
        'ration_card_income': new FormControl(''),
        'salary_slip_it_return_income': new FormControl('')
      }),
      // charity OP order supporting documents (same as documentIds on charity_request_details.json)
      'documentIds': new FormControl([]),
      'total_amount': new FormControl(),
      'discount': new FormControl(0),
      'tax': new FormControl(0),
      'net_amount': new FormControl(),
      'received_amount': new FormControl(),
      'net_receivable_amount': new FormControl(),
       'is_sponsor_fund_applied': new FormControl(),
      'authorised_amount': new FormControl(),
      'patient_amount': new FormControl(),
      'final_amount': new FormControl(),
      'consumed_amount': new FormControl(),
      'net_receivable_payer_amount': new FormControl(0),
      'is_used_deposit': new FormControl(false),
      'deposit_amount': new FormControl({ value: 0, disabled: true }),
      'used_deposit_amount': new FormControl(0),
      'is_discount': new FormControl(false),
      'type': new FormControl(''),
      'patient_criticality_code': new FormControl(''),
      "override_scheme": new FormControl(false),
      'discount_reason': new FormControl(''),
      'discount_type': new FormControl('amount'),
      'discount_on': new FormControl(''),
      'discount_value': new FormControl(0, Validators.min(0)),
      'discount_authorized_by': new FormControl(''),
      'discount_authorized_by_id': new FormControl(''),
      'discount_authorized_by_name': new FormControl(''),
      'payment_detail': new FormControl([]),
      'is_due': new FormControl(false),
      'is_guarantor': new FormControl(false),
      'guarantor_details' : new FormControl([]) ,
      'item_charges': new FormControl(false),
      'item_name': new FormControl(''),
      'noOfInstallment': new FormControl(),
      'recovery': new FormControl(''),
      'due_reason': new FormControl(''),
      'sponsor': new FormControl(''),
      'due_amount': new FormControl(0),
      'due_authorised_by_id': new FormControl(''),
      'due_authorised_by_name': new FormControl(''),
      'remarks': new FormControl(''),
      'billing_reason': new FormControl(''),
      'scheme': new FormControl(''),
      'scheme_name': new FormControl(''),
      'deposit_wallet_id': new FormControl(),
      'otp': new FormControl(),
      'is_default_amount': new FormControl(0),
      'used_advance_amount': new FormControl(0),
      'is_default_amount_optical': new FormControl(0),
      'advance_payment': new FormControl(false),
      'is_visible': new FormControl(false),
      'payment_enable': new FormControl(false),
      'otp_due': new FormControl(),
      'sponsor_code': new FormControl(),
      'sponsorName': new FormControl(),
      'receipt_name': new FormControl(),
      'receipt_code': new FormControl(),
      'recipt_no': new FormControl(),
      // 'employeeId': new FormControl(),
      // 'total_guerrentied_amount': new FormControl(),
      'total_available_balance': new FormControl(),
      'sponsor_type': new FormControl(),
      'sponsor_fund': new FormControl([]),
      'deposits': new FormControl([]),
      'sponsor_name': new FormControl([]),
      'sanctioned_date_time': new FormControl([]),
      'letter_no': new FormControl([])
    })
  }
  // Paid sum of rows a dataPay re-push keeps; 0 when payment is hidden (discount/due approval) or due is ticked - old reset behaviour
  paidToKeep(rows) {
    if (!Array.isArray(rows) || (!this.showPaymentdeails && !this.is_opt_sm_stage) || this.paymentForm.controls['is_due'].value)
      return 0;
    return Number(rows.reduce((sum, row) => sum + (Number(row.received_amount) || 0), 0).toFixed(this.appService._currentSessionData.currency_decimal_limit || 2));
  }
  // final / payer-authorised / used-deposit amounts that net_receivable_amount is derived from
  paymentTotalsKey(final, authorised) {
    return [final, authorised, this.paymentForm.controls['used_deposit_amount'].value].map(v => Number(v || 0)).join();
  }
  // Puts the rows (and the net they left) back only if the totals are unchanged; changed totals leave them
  // cleared (old behaviour) so a partial payment isn't left against the new amount. True when restored
  restorePaymentRows(rows, net, totals) {
    const form = this.paymentForm.controls;
    const paid = this.paidToKeep(rows);
    if (!paid)
      return false;
    if (this.paymentTotalsKey(form['final_amount'].value, form['authorised_amount'].value) != totals)
      return false;
    form['payment_detail'].setValue(rows);
    form['net_receivable_amount'].setValue(net);
    Object.assign(this.amounts, { sum: paid, paymentData: rows, paidAmount: rows.map(row => row.received_amount), netPayableAmount: net });
    return true;
  }

  resetAllData(value) {
    // this.showPaymentdeails = true;
    if (this.paymentForm.controls['payment_detail'] && this.paymentForm.controls['payment_detail'].value && this.paymentForm.controls['payment_detail'].value.length > 0) {
      if (this.compositeArrayComponent) {
        this.compositeArrayComponent.removeAllItems();
        this.paymentForm.controls['payment_detail'].setValue([]);
      }
    }
    this.resetDueCheckbox();
    if(this.paymentForm.controls['is_sponsor_fund_applied'].value == false){
      this.paymentForm.controls['is_used_deposit'].setValue(false);
    this.paymentForm.controls['deposits'].setValue([]);
    this.visibility.enableUseDepositAmt = true;
    this.amounts.is_used_deposit = false;
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
    }
    if(this.paymentForm.controls['is_sponsor_fund_applied'].value == true){
      this.paymentForm.controls['net_receivable_amount'].setValue( this.paymentForm.controls['net_receivable_amount'].value - this.paymentForm.controls['used_deposit_amount'].value)
    }
    if ((value.scheme_id != undefined || value.schemeId != undefined) && ((value.scheme_id || value.schemeId) || (this.responses.schemeResponse != undefined && (this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'OP Edit Billing')))) {
      this.visibility.schemeVisible = true;
      this.visibility.disableField = false;
      this.amounts.is_discount = true;
      this.visibility.discountFieldVisible = false;
      this.paymentForm.controls['is_discount'].setValue(true);
      this.bindDropDownsFormExternalResources('scheme');
      this.paymentForm.controls['type'].setValue('scheme');
      if (this.dataSet && this.dataSet.transaction_type && (this.dataSet.transaction_type == "OP Billing" || this.dataSet.transaction_type == 'OP Edit Billing')) {
        if (this.appService.getUniversalConfig('multi_care_type')) {
          this.schemeApiSignature['args'] = "care_type:" + this.appService.getDynamicFunctions("getCurrentCareType")
        }
      }
      if (this.responses.schemeResponse != undefined && (this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'Pharmacy Billing' || this.dataSet.transaction_type == 'OP Edit Billing')) {
        value['id'] = value.scheme_id;
        if (value.scheme_discount_applicable && value.scheme_id != this.paymentForm.controls['scheme'].value) {
          this.formService.blockMapping[1]['default_open'] = true;
          this.paymentForm.controls['type'].setValue('scheme');
          this.visibility.schemeVisible = true;
          this.paymentForm.controls['scheme'].setValue(value.scheme_id);
          this.paymentForm.controls['scheme_name'].setValue(value.scheme_name);
          this.schemeresource.datasource.args = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + ((this.value_data && this.value_data.payer_details && this.value_data.payer_details.payer_id) ? this.value_data.payer_details.payer_id : '')
          setTimeout(() => {
            if (this.multiselectscheme)
              this.multiselectscheme.setMultiselect(value);
          }, 10);
        }
        else if (value.scheme_id == this.paymentForm.controls['scheme'].value) { }
        else if (value.schemeId == this.paymentForm.controls['scheme'].value) { }
        else {
          this.paymentForm.controls['is_discount'].setValue(false);
          this.discountchecked = false;
          this.visibility.discountFieldVisible = true;
          this.visibility.schemeVisible = false;
          this.visibility.disableField = true;
          this.paymentForm.controls['type'].setValue('direct');
          this.formService.blockMapping[1]['default_open'] = false;
        }

      }
      if (this.responses.schemeResponse == undefined) {
        // if(this.dataSet.orderedFrom == "Optical Order"){
        //   this.schemeApiSignature['args'] = "applicable_on:CUSTOM_SCHEME"
        // }
        this.baseService.getByDataSource(this.schemeApiSignature).subscribe(res => {
          if (res.errCode == 0 && res.count > 0 && this.responses.schemeResponse == undefined) {
            if (this.dataSet.transaction_type == 'Pharmacy Billing' || this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'Optical Billing' || this.dataSet.transaction_type == 'optical billing' || this.dataSet.transaction_type == 'OP Edit Billing')
              this.formService.blockMapping[1]['default_open'] = true;
            this.responses.schemeResponse = res.resource;
            this.visibility.schemeVisible = true;
            this.visibility.disableField = false;
            this.amounts.is_discount = true;
            this.visibility.discountFieldVisible = false;
            this.paymentForm.controls['is_discount'].setValue(true);
            this.paymentForm.controls['scheme'].setValue(value.scheme_id ? value.scheme_id : value.schemeId);
            this.paymentForm.controls['scheme_name'].setValue(value.scheme_name ? value.scheme_name : value.schemeName);
          }
        });
      }

    } else if (value.discount == 0 && ((!this.value_data) || (this.value_data?.care_plan_discount_apply !== true))) {
      if (this.amounts && (!this.schm_rmvd || value.Payer_Changed)) {
        this.amounts.is_discount = false;
      }
      if (!this.schm_rmvd || value.Payer_Changed) {
        if ((this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'OP Edit Billing') && this.formService && this.formService.blockMapping && this.formService.blockMapping[1])
          this.formService.blockMapping[1]['default_open'] = false;
        this.visibility.disableField = true;
        this.paymentForm.controls['is_discount'].setValue(false);
        this.visibility.discountFieldVisible = true;
        this.visibility.schemeVisible = false;
        this.paymentForm.controls['discount_on'].reset('');
        this.paymentForm.controls['discount_type'].reset('amount');
        this.paymentForm.controls['discount_reason'].reset('');
        this.paymentForm.controls['discount_authorized_by'].reset('');
        this.paymentForm.controls['discount_authorized_by_id'].reset('');
        this.paymentForm.controls['discount'].reset(0);
        this.paymentForm.controls['scheme'].reset('');
        this.paymentForm.controls['type'].setValue('direct');
        this.paymentForm.controls['discount_authorized_by_name'].reset('');
      }
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, typeToggled: true });
    }
    if (this.paymentForm.controls['discount_type'].value == "percentage" && this.paymentForm.controls['discount_on'].value == "bill" && value  && value.op_amount_value)
    {
      if(value.op_amount_value.discount_value > 0)
      this.paymentForm.controls['discount_value'].setValue(Number(value.op_amount_value.discount_value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
      this.paymentForm.controls['discount_value'].setValue(value.op_amount_value.discount_value)
    }
    else {
      if (value && value.op_amount_value) {
        if(value.op_amount_value.discount > 0)
        this.paymentForm.controls['discount_value'].setValue(Number(value.op_amount_value.discount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      else
      this.paymentForm.controls['discount_value'].setValue(value.op_amount_value.discount)
      }        
      if(this.value_data?.care_plan_discount_apply && this.value_data.care_plan_discount_apply == true)
      {
              setTimeout(() => {
                          this.formService.blockMapping[1]['default_open'] = true;
                        this.paymentForm.controls['is_discount'].setValue(true);
                this.paymentForm.controls['type'].setValue(value.op_amount_value.type)
                      this.paymentForm.controls['discount_on'].setValue(value.op_amount_value.discount_on)
              this.paymentForm.controls['discount_type'].setValue(value.op_amount_value.discount_type)
                   }, 3000)

      }
    }
  }

  ngOnInit() {
    PaymentModeFlagsDecorator.loadConfig(this.baseService, () => PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent));
    this.hideCharitySections();
    //this.amounts.is_discount=true;
    if (this.itemresource && this.itemresource.question && this.itemresource.question.options)
      return
    this.itemresource = {
      "datasource": {
        "application": "facility-management",
        "resource": "delivery_charges_master",
        "query_id": "GET_PAGE",
        "args":"noCount:1",
        "filter": "status:active",
        "search_columns":"item_name",
      },
      controls: {
        item: {
          value: ""
        }
      },
      question: {
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": false
        },
        getterKey: 'id',
        getterValue: 'item_name',
        req_keys: 'all',
        key: "item",
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": true
      }
    }
    this.initializeAmt();
    this.getConfigOverridScheme();
    this.initializeVisibility();
    this.getDepositAmount();
    this.getconfigforbookorder();
    this.getconfigfordue();
    this.getConSapOp()
   // this.getconfigforPaymentDecimal();
    if (this.paymentForm != undefined && this.paymentForm.controls != undefined && this.paymentForm.controls['is_discount'] != undefined && this.value_data != undefined && this.value_data.authorized_by_id != undefined) {
      this.opupdate();

      // this.schemeSetup(valueorder);
    }
      //   if (this.paymentForm != undefined && this.paymentForm.controls != undefined && this.paymentForm.controls['is_discount'] != undefined && this.value_data != undefined && this.value_data.care_plan_discount_apply && this.dataSet?.transaction_type == 'OP Billing') {
      //       // this.navVar[this.findIndexByFieldName('discount')].show = true; // earlier it was 3
      //     setTimeout(() => {
      // this.opupdate();
      //           }, 1000);


      // this.schemeSetup(valueorder);
   // }
    // this.schemedatasource = {
    //   "application": "facility-management",
    //   "resource": "scheme_detail",
    //   "query_id": "GET_SCHEME_DETAILS",  
    //   "args":"uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + this.dataSet.payerID

    // }
    // this.question = new SearchAndSelect({
    //   datasource: this.schemedatasource,
    //   defaultsetting: this.defaultsetting,
    //   getterKey: 'scheme_name',
    //   getterValue: 'scheme_name',
    //   options: true,
    //   type: "string",
    //   value: ""
    // }); 
    this.blockMapping = this.navVar;
    //sets block mapping in formservice
    if (window.location.href.includes("opbilling")) {
      this.navVar[this.findIndexByFieldName('advance')].show = false; // earlier it was 3
    }

    this.formService.setBlockMapping(this.blockMapping);
    this.checkDuplicatePaymentMode();
    this.isSponsorWorkFlowEnable()
  }


  findIndexByFieldName(fieldName: string): number {
    const index = this.navVar.findIndex((item: any) => item.field_name === fieldName);
    if (index === -1) {
      console.error(`Field name '${fieldName}' not found in navVar`);
    }
    return index;
  }
  overrideScheme(event, key) {
    if (event.target.checked) {
      this.amounts.override_scheme = true;
      this.visibility.disableDiscountValue = true;
    } else {
      this.amounts.override_scheme = false;
      this.visibility.disableDiscountValue = false;
    }
    this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, discount_type: this.paymentForm.controls['type'].value, 'scheme_name': this.paymentForm.controls['scheme_name'].value, 'schemeId': this.paymentForm.controls['scheme'].value, discount: this.paymentForm.controls['discount_value'].value, 'override_scheme': this.amounts.override_scheme });
  }
getConSapOp()
{
      this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_153', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result && result.errCode == 0 && result.resource && result.resource[0]) {
          result = result.resource[0];
          this.sap_opt_config = result.config_value;
        }
      });
}
  addedresourceInfo() {
    console.log("this.patientInfo ", this.patientInfo);
    if (this.schemeresource && this.schemeresource.question && this.schemeresource.question.options)
      return
    this.schemeresource = {
      "datasource": {
        "application": "facility-management",
        "resource": "scheme_detail",
        "query_id": "GET_SCHEME_DETAILS",
        "args": "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + ((this.dataSet && this.dataSet.payer) ? this.dataSet.payer : '')
      },
      controls: {
        scheme: {
          value: ""
        }
      },
      question: {
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": false
        },
        "req_keys": [
          "id",
          "scheme_name"
        ],
        getterKey: 'id',
        getterValue: 'scheme_name',
        key: "id"
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": false
      }
    }
    // if(this.dataSet.orderedFrom == "Optical Order"){
    //   this.schemeresource.datasource['args'] += ",applicable_on:CUSTOM_SCHEME"
    // }
  }

  removeFirstZero(event, formControlName) {
    console.log(event.target.value);
    if(this.dataSet && this.dataSet.isDiscountLessThan1Applicable && event.key == "."){
      // return
    }else if (event.target.value.charAt(0) == 0) {
      let val = +event.target.value.replace(/^0+/, '');
      this.paymentForm.controls[formControlName].setValue(val);
    }
  }
  getDepositAmount() {
    try {
      // let args = '';
      // if (this.dataSet.preValue) {
      //   args = 'uhId:' + this.dataSet.preNo;
      // } else {
      //   args = 'uhId:' + this.patientInfo.uhId;
      // }
      var data = {
        args:
          "uhId:" + this.patientInfo.uhId + this.deposit_arg
      }
      if (!this.paymentForm.controls['deposit_amount'].value && !this.paymentForm.controls['deposit_wallet_id'].value) {
        this.baseService.get("GET_TOTAL_DEPOSIT_BY_UHID", data.args, "deposit_wallet", "payment").subscribe(res => {
          if (res.errCode == 0) {
            this.responses.depositApiResponse = res.resource;
            if (res.resource.length > 0) {
              this.paymentForm.controls['deposit_amount'].setValue(this.responses.depositApiResponse[0].available_amount);
              this.paymentForm.controls['deposit_wallet_id'].setValue(this.responses.depositApiResponse[0].id); //setting wallet id in case of using deposit
            }
          }
        })
      } else {
        //TODO
      }
    } catch (e) {
      console.error('Error while fetching deposit', e);
    }
  }
  toggleCriticality(e)
  {
        this.critcality_Data = this.responses?.patientCriticalityData?.find(val => {
      return val.code == e?.target?.value;
    });
  }
  getconfigfordue() {
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_804', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result.errCode == 0) {
          result = result.resource[0];
          this.due_config = result.config_value;
        }
      });
  }
  getconfigforGuarantor(){
    // guarantor is an OP Billing-only feature (only op-billing submits guarantor_mapping_details);
    // elsewhere (e.g. OP Pharmacy) treat it as off so the employee recovery fields show instead
    if (this.dataSet?.transaction_type != 'OP Billing') {
      this.guarantor_config = 'no';
      this.resetGuarantor();
      return;
    }
     this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_901', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result.errCode == 0) {
          result = result.resource[0];
          this.guarantor_config = result.config_value;
        }
        if (this.guarantor_config != 'yes') {
          this.resetGuarantor();
        }
      });
  }

  resetGuarantor() {
    this.amounts.is_guarantor = false;
    this.totalGuaranteedAmount = 0;
    this.paymentForm?.controls['is_guarantor']?.setValue(false);
    this.paymentForm?.controls['guarantor_details']?.setValue([]);
  }

  // getconfigforPaymentDecimal() {
  //   this.baseService.get('GET_CONFIG', 'module_code:facility-management,config_code:facility_mgnt_0013', 'facility_config_mapping', 'facility-management').subscribe(
  //     result => {
  //       console.log("res is....." + result)
  //       if (result.errCode == 0) {
  //         result = result.resource[0];
  //         if (result.config_value == "No") {
  //           this.configValueDecimal = "No";
  //         }
  //         if (result.config_value == "Yes") {
  //           this.configValueDecimal = "Yes";
  //         }


  //       }
  //     });
  // }

  onrecoverySelect(e) {
    this.rec_uhId = e.alldata.uhId;
    this.rec_employeeId = e.alldata.emp_no;
    this.rec_name = e.alldata.patient_name;

  }
  onrecoveryDeselect() {

  }
  emprecoveryselect(e) {
    let val;
    val = this.recoveryData.find(x => x.id == e);
    this.rec_uhId = val.uhId;
    this.rec_employeeId = val.emp_no;
    this.rec_name = val.patient_name;
  }
  opupdate() {
    this.visibility.disableField = false;
    this.paymentForm.controls['is_discount'].setValue(true);
    // this.paymentForm.controls['discount_authorized_by'].setValue(this.value_data.authorized_by_id != undefined ? this.value_data.authorized_by_id : "");
    this.paymentForm.controls['type'].setValue(this.value_data.type);
    this.paymentForm.controls['discount_on'].setValue(this.value_data.discount_on);
    this.paymentForm.controls['discount_type'].setValue(this.value_data.discount_type);
    this.paymentForm.controls['discount_reason'].setValue(this.value_data.discount_reason);
    if(this.value_data.discount_value > 0)
    this.paymentForm.controls['discount_value'].setValue(Number(this.value_data.discount_value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
  else
  this.paymentForm.controls['discount_value'].setValue(this.value_data.discount_value)
    this.paymentForm.controls['discount_authorized_by'].setValue(this.value_data.authorized_by_id);
    this.paymentForm.controls['discount_authorized_by_id'].setValue(this.value_data.authorized_by_id);
  }
  navigateToSection(elementId: string, blockId) {
    this.openScrollBox(elementId, blockId);
    this.activeKey = elementId;
    let el = document.getElementById(elementId);
    el.scrollIntoView();
    if (this.config.expanded_form) {
      window.scroll({ top: el.offsetTop, behavior: "smooth" });
    } else {
      // console.log("Top ",el.getBoundingClientRect().top);
      window.scroll({ top: el.getBoundingClientRect().top - 60, behavior: "smooth" });
    }
    //this.viewportScroller.scrollToAnchor(elementId);
    // window.location.hash = '';
    // window.location.hash = section;
  }
  openScrollBox(name, blockId) {
    this.activeKey = name;
    if (!this.config.expanded_form) {
      if (this.formService != undefined && this.formService.blockMapping != undefined) {
        this.formService.blockMapping.forEach((block, index) => {
          if (block['block_id'] == blockId || block['block_id'] == "bill_summary" || block['block_id'] == "payment_details") {
            this.formService.blockMapping[index]['default_open'] = true;
          } else {
            this.formService.blockMapping[index]['default_open'] = false;
          }
        })
      }
    }
  }
  openaccordianBox(name, blockId) {
    this.activeKey = name;
    if (!this.config.expanded_form) {
      if (this.formService != undefined && this.formService.blockMapping != undefined) {
        this.formService.blockMapping.forEach((block, index) => {
          if (block['block_id'] == blockId) {
            if (this.formService.blockMapping[index]['default_open'] == true)
              this.formService.blockMapping[index]['default_open'] = false;
            else
              this.formService.blockMapping[index]['default_open'] = true;
          }
        })
      }
    }
  }
  initializeVisibility() {
    this.visibility = {
      "discountFieldVisible": true,
      "schemeVisible": false,
      'showField': false,
      'disableFields': true,
      'enableUseDepositAmt': true,
      enableisadvance: true,
      'disableField': true,
      'disableDiscountValue': false,
      'validate': false,
      'noSubmit': false
    }
    if(this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['type'] && this.paymentForm.controls['type'].value === "scheme" && this.dataSet && this.dataSet.transaction_type == "optical billing")
      {
        this.visibility.discountFieldVisible = false;
        this.visibility.schemeVisible = true;
      }
  }
  getconfigforbookorder() {
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:032', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0) {
          result = result.resource[0];
          this.book_config = result.config_value;
          if ((this.config != undefined && this.config.application != undefined && this.config.application == 'optical'))
            this.navVar[this.findIndexByFieldName('advance')].show = true; /// 3
        }
      });
  }
  isadvance(event) {
    if (event.target['checked']) {
      let amt = Math.round(this.paymentForm.controls.net_receivable_amount.value);
      this.paymentForm.controls.is_default_amount.setValue(amt);
      // this.paymentForm.controls.net_receivable_amount.setValue(amt);
      this.visibility.enableisadvance = false;
      this.is_advance_checked = true;
    }
    else {
      this.paymentForm.controls.is_default_amount.setValue(0)
      this.paymentForm.controls.net_receivable_amount.setValue(Number(this.paymentForm.controls.net_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2))

      this.visibility.enableisadvance = true;
      this.is_advance_checked = false;
    }
  }
  initializeAmt() {
    this.amounts = {
      'sum': 0,
      'remainingDue': 0,
      'is_due': false,
      'is_guarantor' : false,
      is_discount: false,
      'item_charges' : true,
      'discountValue': 0,
      'netAmount': 0,
      'paymentData': [],
      'paidAmount': [],
      'uniquePayment': [],
      'netPayableAmount': 0,
      'depositAmount': 0,
      'names': [],
      'localNet': 0,
      'localDeposit': 0,
      'localDue': 0,
      'removedAmount': 0,
      'timer': 30,
      'otp_required': false,
      'otp_verified': false,
      'otp_required_due': false,
      'otp_verified_due': false
    }
  }
  checkAdvance() {
    // if (this.paymentForm.controls.is_default_amount.value > this.paymentForm.controls.net_amount.value) {
    //   this.alertService.error("Advance cannot be greater than net amount");
    //   this.paymentForm.controls.is_default_amount.setValue(this.paymentForm.controls.net_amount.value);
    // }
    this.paymentForm.controls.net_receivable_amount.setValue(this.paymentForm.controls.net_amount.value - this.paymentForm.controls.is_default_amount.value)

  }

  // getAdvanceAmount() {
  //   try {
  //     var data = {
  //       args:
  //         "uhId:" + this.patientInfo.uhId + ",admissionId:" + this.dataSet.orderId
  //     }
  //     // if (!this.paymentForm.controls['deposit_amount'].value && !this.paymentForm.controls['deposit_wallet_id'].value) {
  //       this.baseService.get("GET_TOTAL_DEPOSIT_BY_UHID", data.args, "deposit_wallet", "payment").subscribe(res => {
  //         if (res.errCode == 0) {
  //           this.responses.depositApiResponse = res.resource;
  //           let d = JSON.stringify(this.responses.depositApiResponse)
           
  //           let Obj ={
  //             isAdvance:this.is_advance_checked,
  //             d:d
  //           }
  //           localStorage.setItem("iss____d",JSON.stringify(Obj));
  //           let amt = res.resource[0].available_amount
  //           this.paymentForm.controls.is_default_amount.setValue(amt);
  //           this.paymentForm.controls.advance_payment.setValue(true);
  //           this.paymentForm.controls.is_default_amount.disable();
  //           this.paymentForm.controls.advance_payment.disable();
  //           this.paymentForm.controls.net_receivable_amount.setValue(this.paymentForm.controls.net_amount.value - this.paymentForm.controls.is_default_amount.value)
  //           this.visibility.enableisadvance = true;
  //           this.is_advance_checked = true;
  //         }
  //       })
  //     // } else {
  //     //   //TODO
  //     // }
  //   } catch (e) {
  //     console.error('Error while fetching deposit', e);
  //   }
  // }

  toggleUseDeposit(event, name) {
    this.apiCheck = false;
    if (event.target['checked']) {
      this.navVar[this.findIndexByFieldName('remarks')].default_open = true; // 6
      this.visibility.enableUseDepositAmt = false;
      this.amounts.is_used_deposit = true;
      let sum = this.paymentForm.controls['net_receivable_amount'].value - this.paymentForm.controls['used_deposit_amount'].value
        this.paymentForm.controls['received_amount'].setValue(sum);
        if(sum > 0){
          this.paymentForm.controls['net_receivable_amount'].setValue(Number(sum).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
        }
        else{
          this.paymentForm.controls['net_receivable_amount'].setValue(sum);
        }
        this.resetPaymentDetail();
        if(this.amounts.is_due){
          this.resetDueCheckbox();
        }
      // if (this.paymentForm.controls['deposit_amount'].value!=undefined){
      //   if (this.paymentForm.controls['deposit_amount'].value > this.paymentForm.controls['net_receivable_amount'].value){
      //     this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['net_receivable_amount'].value); 
      //   }
      //   else{
      //         this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['deposit_amount'].value); 
      //         let sum =this.paymentForm.controls['net_receivable_amount'].value - this.paymentForm.controls['used_deposit_amount'].value
      //         this.paymentForm.controls['received_amount'].setValue(sum);
      //       }
      // }

      try {
        // let args = '';
        // if (this.dataSet.preValue) {
        //   args = 'uhId:' + this.dataSet.preNo;
        // } else {
        //   args = 'uhId:' + this.patientInfo.uhId;
        // }
        var data = {
          args:
            "uhId:" + this.patientInfo.uhId +this.deposit_arg
        }
        // if(this.dataSet && this.dataSet.patient_type != "OP"){
        //   this.baseService.get("GET_TOTAL_DEPOSIT_BY_UHID", data.args, "deposit_wallet", "payment").subscribe(res => {
        //     if (res.errCode == 0) {
        //       this.responses.depositApiResponse = res.resource;
        //       if (res.resource.length > 0) {
        //         this.paymentForm.controls['deposit_amount'].setValue(this.responses.depositApiResponse[0].available_amount);
        //         this.paymentForm.controls['deposit_wallet_id'].setValue(this.responses.depositApiResponse[0].id); //setting wallet id in case of using deposit
        //         this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
  
        //         if (this.paymentForm.controls['deposit_amount'].value > 0) {
        //           this.resetPaymentDetail();
        //           if (this.paymentForm.controls['deposit_amount'].value != undefined) {
        //             if (this.paymentForm.controls['deposit_amount'].value > this.paymentForm.controls['net_receivable_amount'].value || this.paymentForm.controls['deposit_amount'].value == this.paymentForm.controls['net_receivable_amount'].value) {
        //               this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['net_receivable_amount'].value);
        //               this.paymentForm.controls['net_receivable_amount'].setValue(0);
        //             }
        //             else {
        //               this.paymentForm.controls['used_deposit_amount'].setValue(this.paymentForm.controls['deposit_amount'].value);
        //               let sum = this.paymentForm.controls['net_receivable_amount'].value - this.paymentForm.controls['used_deposit_amount'].value
        //               this.paymentForm.controls['received_amount'].setValue(sum);
        //               if(sum > 0)
        //               this.paymentForm.controls['net_receivable_amount'].setValue(Number(sum).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
        //             else
        //             this.paymentForm.controls['net_receivable_amount'].setValue(sum);
        //             }
        //           }
  
        //         }
        //       } else {
        //         this.visibility.enableUseDepositAmt = true;
        //         this.alertService.error("Amount is not deposited");
        //       }
        //     }
        //   })
        // }
      } catch (e) {
        console.error('Error while fetching deposit', e);
      }
    } else {
      let deposit = 0;
      this.visibility.enableUseDepositAmt = true;
      this.amounts.is_used_deposit = false;
      this.paymentForm.controls.deposits.setValue([]);
      this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
      deposit = this.paymentForm.controls['used_deposit_amount'].value;
      this.amounts.netPayableAmount = Number(this.amounts.netPayableAmount) + Number(deposit);
      if(this.amounts.netPayableAmount > 0)
      this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
    this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
      this.paymentForm.controls['used_deposit_amount'].setValue(0);
      this.amounts.depositAmount = 0
      this.resetDueCheckbox();
      this.resetPaymentDetail();
      this.resetDiscountCheckbox();
    }
  }
  onDepositAdd(e){
    let sum;
    let total_payment_amount = 0;
    if(e.action == "edit"){
      this.updatedReciptNoRequired = false;
      if(this.amounts.is_due){
        this.resetDueCheckbox();
      }
    }
    this.apiCheck = false;
    this.total_service_amount = 0
    let netReceivableAmount = this.paymentForm.controls['net_receivable_amount'].value;
    let serviceAmount = e.items.length - 1
    let editFlagTest = false;
    if(this.paymentForm && this.paymentForm.controls["payment_detail"].value && this.paymentForm.controls["payment_detail"].value.length >0){
      this.paymentForm.controls["payment_detail"].value.forEach(paymentCheck =>{
        total_payment_amount = Number(total_payment_amount) + Number(paymentCheck.received_amount);
      })
    }
    e.items.forEach((element, index) =>{
      if(element.used_deposit_amount != undefined){
          this.total_service_amount = Number(this.total_service_amount)+Number(element.used_deposit_amount)
          if(e && e.removedItem && e.removedItem.used_deposit_amount && editFlagTest == false){
            editFlagTest = true
            this.total_edit_service_amount = Number(this.paymentForm.controls['net_receivable_amount'].value) + Number(e.removedItem.used_deposit_amount)
          }
          this.paymentForm.controls['used_deposit_amount'].setValue(this.total_service_amount);
          if(this.paymentForm.controls['net_receivable_amount'].value != this.paymentForm.controls['final_amount'].value){
            sum = this.paymentForm.controls['final_amount'].value - this.total_service_amount - total_payment_amount;
          }
          else{
            sum = this.paymentForm.controls['net_receivable_amount'].value - this.total_service_amount - total_payment_amount;
          }
          if(e.action != "edit"){
            this.paymentForm.controls['received_amount'].setValue(sum);
            if(sum > 0){
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(sum).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
            }
            else{
              this.paymentForm.controls['net_receivable_amount'].setValue(sum);
            }
          }
          let patientAmount = this.paymentForm.controls['final_amount'].value;
          if (this.total_service_amount > patientAmount) {
            if(e.action != "edit"){
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(netReceivableAmount).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              this.paymentForm.controls['used_deposit_amount'].setValue(this.total_service_amount - element.used_deposit_amount);
              if(total_payment_amount>0){
                this.paymentForm.controls["net_receivable_amount"].setValue(Number(patientAmount) - Number(this.total_service_amount)- Number(this.paymentForm.controls['due_amount'].value));
                this.paymentForm.controls['payment_detail'].reset();
              }
            }
            if(e.action == "edit"){
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.total_edit_service_amount).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              this.paymentForm.controls['used_deposit_amount'].setValue(Number(this.total_service_amount) - Number(e.items[index].used_deposit_amount));
              if(total_payment_amount >0){
                this.paymentForm.controls["net_receivable_amount"].setValue(Number(patientAmount) - Number(this.total_service_amount)- Number(this.paymentForm.controls['due_amount'].value));
                this.paymentForm.controls['payment_detail'].reset();
              }
            }
            this.alertService.error('Can Not Use Deposit More Than Net Payable Amount. Used Deposit Resetting.', 'Invalid Use Deposit Error');
            e.items.splice(index);
            this.compositeArrayComponent.removeRow(e.items.length - 1);
            this.amounts.depositAmount = 0;
            return;
        }
        if(this.total_service_amount < patientAmount){
          if(total_payment_amount >0){
            this.paymentForm.controls["net_receivable_amount"].setValue(Number(patientAmount) - Number(this.total_service_amount)- Number(this.paymentForm.controls['due_amount'].value));
            this.paymentForm.controls['payment_detail'].reset();
          }
        }
        if(this.total_service_amount < patientAmount && e.action == "edit"){
          this.paymentForm.controls['net_receivable_amount'].setValue(patientAmount - this.total_service_amount)
          if(total_payment_amount >0){
            this.paymentForm.controls["net_receivable_amount"].setValue(Number(patientAmount) - Number(this.total_service_amount)- Number(this.paymentForm.controls['due_amount'].value));
            this.paymentForm.controls['payment_detail'].reset();
          }
        }
        if(this.total_service_amount == patientAmount && e.action == "edit"){
          this.paymentForm.controls['net_receivable_amount'].setValue(0)
          if(total_payment_amount >0){
            this.paymentForm.controls["net_receivable_amount"].setValue(Number(patientAmount) - Number(this.total_service_amount)- Number(this.paymentForm.controls['due_amount'].value));
            this.paymentForm.controls['payment_detail'].reset();
          }
        }
      }
    });
  }
  resetRealDiscountCheckbox() {
    this.paymentForm.controls['is_discount'].setValue(false);
    this.amounts.is_discount = false;
  }

  resetDiscountCheckbox() {
    this.paymentForm.controls['is_used_deposit'].setValue(false);
    this.amounts.is_used_deposit = false;
    this.paymentForm.controls['deposits'].setValue([]);
    this.visibility.showField = false;
  }
  resetDueCheckbox() {
    this.paymentForm.controls['is_due'].setValue(false);
    this.amounts.is_due = false;
    this.visibility.showField = false;
  }
  bindDropDownsFormExternalResources(discountType?) {
    if(this.paymentForm.controls['discount_on'].value == "service_item")
    this.wkflow_called = false;
    let discountedType = discountType ? discountType : this.paymentForm.controls['type'].value
    try {
      // charity billing: discount by is selectable for scheme discounts too
      if ((discountedType != 'scheme' || this.isCharitySource()) && this.paymentForm.controls['discount'].value && this.paymentForm.controls['discount'].value != "0" && !this.wkflow_called) {
        let s_o_r;
        if (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD Clinical Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_CLINICAL_BILLING_AUTH_CLEARANCE")){
          s_o_r = (this.dataSet.op_amount_value.patientType ? this.dataSet.op_amount_value.patientType : this.dataSet.op_amount_value.patient_details ? this.dataSet.op_amount_value.patient_details.patientType :(this.dataSet.transaction_type.split(" ")[0]).toUpperCase())+ " CLINICAL SPLIT BILL DISCOUNT"
          this.wkflow_called = true;
        }
        else if (this.dataSet && this.dataSet.transaction_type == "Pharmacy Billing" && (this.dataSet.patient_type == "IP" || (this.dataSet && this.dataSet.op_amount_value && this.dataSet.op_amount_value.orderedFrom == "IPD_PHARMACY_SPLIT_BILL_AUTH_CLEARANCE"))){
          s_o_r = "IPD PHARMACY SPLIT BILL DISCOUNT";
        }
        else{
          s_o_r = (this.dataSet.transaction_type.split(" ")[0]).toUpperCase() + " ORDER DISCOUNT"
        }
        // charity OP order: approvers come from the charity workflow master
        let flow_master = "discount";
        if (this.isCharitySource()) {
          flow_master = "charity";
          s_o_r = "CHARITY OP ORDER DISCOUNT";
        }
        this.discountApiSignature.args = "flow_master:" + flow_master + ",total_amount:" + this.paymentForm.controls['total_amount'].value + ",authorization_amount:" + this.paymentForm.controls['discount'].value + ",source_of_request:" + s_o_r
        this.baseService.getByDataSource(this.discountApiSignature).subscribe(res => {
          if (res.errCode == 0) {
            this.wkflow_called = true;
            this.responses.discountResponseData = res.resource;
            if(this.paymentForm.controls['discount_authorized_by'].value && this.paymentForm.controls['discount_authorized_by'].value != '' && !this.visibility.disableField)
            this.paymentForm.controls['discount_authorized_by'].setValue('')
          } else {
            this.responses.discountResponseData = [];
            this.alertService.error(res.message);
            if(this.paymentForm.controls['discount_authorized_by'].value && this.paymentForm.controls['discount_authorized_by'].value != '')
              this.paymentForm.controls['discount_authorized_by'].setValue('')
          }
        });
      }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.discountTypeData == undefined) {
          this.baseService.getByDataSource(this.discountTypeApi).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.discountTypeData = res.resource;
            }
          })
        }
        if(this.responses?.patientCriticalityData == undefined)
        {
                this.baseService.getByDataSource(this.patientCriticalityApi).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.patientCriticalityData = res.resource;
            }
          }) 
        }
      // }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.reasonNameDiscountData == undefined) {
          this.baseService.getByDataSource(this.reasonTypeDiscountApi).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.reasonNameDiscountData = res.resource;

            }
          })
        }
      // }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.discType == undefined) {
          this.baseService.getByDataSource(this.discTypeApiSignature).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.discType = res.resource;
            }
          });
        }
      // }
      // if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
        if (this.responses.discOn == undefined) {
          this.baseService.getByDataSource(this.discOnApiSignature).subscribe(res => {
            if (res.errCode == 0) {
              this.responses.discOn = res.resource;
              if ((discountType != undefined || (this.paymentForm.controls['scheme'].value || this.paymentForm.controls['scheme_name'].value)) && !window.location.href.includes("approved_opticalorder") )
                this.paymentForm.controls['type'].setValue('scheme');
            }
          })
        }
      // }
    } catch (e) {
      console.error('Error while fetching discount properties', e);
    }
  }
  fetchDiscount(event, name) {
    this.is_opt_sm_stage = false;
    if (!event.target['checked']) {
      this.remarksMandatory = false;
      this.checkremarksmandatory()
    }
    this.paymentForm.controls['type'].setValue('direct');
    let tax = 0;
    let totalAmount = this.paymentForm.controls['total_amount'].value;
    if (this.paymentForm.controls['is_used_deposit'].value == true) {
      this.amounts.depositAmount = 0;
      this.paymentForm.controls['final_amount'].setValue(this.paymentForm.controls['final_amount'].value + this.paymentForm.controls['used_deposit_amount'].value)
      this.paymentForm.controls['used_deposit_amount'].setValue(0);
      this.paymentForm.controls['deposits'].setValue([]);
    }
    if (this.dataSet && (this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'IP Billing') && this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['tax'] && this.paymentForm.controls['tax'].value) {
      this.paymentForm.patchValue({ discount: 0, discount_value: this.value_data != undefined && this.value_data.discount_value != undefined ? this.value_data.discount_value : 0});
    }
    else{
      this.paymentForm.patchValue({ discount: 0, discount_value: this.value_data != undefined && this.value_data.discount_value != undefined ? this.value_data.discount_value : 0, net_amount: totalAmount });
    }
    //this.amounts.netPayableAmount = totalAmount + tax;
    if (event.target['checked']) {
      this.navVar[this.findIndexByFieldName('remarks')].default_open = true;
      this.amounts.is_discount = true;
      this.discountchecked = true;
      //this.validateRemark(event, name);
      this.visibility.disableField = false;
      this.otp_visibility = false
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value, is_manual_checked : true });
      this.bindDropDownsFormExternalResources();
      this.resetDueCheckbox(); //resetting due amount field to fill new values
      this.resetPaymentDetail(); //resetting payment details field to fill new values
      this.resetDiscountCheckbox();
    } else {
      this.otp_visibility = false
      this.discountchecked = false;
      this.visibility.discountFieldVisible = true;
      this.visibility.schemeVisible = false;
      this.visibility.disableField = true;
      this.amounts.override_scheme = false;
      this.amounts.is_discount = false;
      if (this.override_config) {
        this.paymentForm.controls['override_scheme'].setValue(false);
        this.amounts.override_scheme = false;
      }
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, override_scheme: false, is_manual_checked : true });
      // RESETTING DISCOUNT ROW ELEMENTS VALUES
      this.paymentForm.controls['discount_on'].reset();
      this.paymentForm.controls['discount_type'].reset('amount');
      this.paymentForm.controls['discount_value'].reset(0);
      this.paymentForm.controls['discount_authorized_by'].reset();
      this.paymentForm.controls['discount_authorized_by_id'].reset();
      this.paymentForm.controls['discount'].reset(0);
      this.paymentForm.controls['scheme'].reset('');
      this.paymentForm.controls['discount_reason'].reset('');
      this.paymentForm.controls['used_deposit_amount'].setValue(0);
      this.paymentForm.controls['otp'].reset('');
      if (!this.paymentForm.controls['is_due'].value)
        this.showPaymentdeails = true;
      this.showDeposit = true;
      this.resetDueCheckbox(); //resetting due amount field to fill new values
      this.resetPaymentDetail(); //resetting payment details field to fill new values
      this.resetDiscountCheckbox()
    }
  }

  toggleIsDue(event, name) {
    if (!event.target['checked']) {
      this.remarksMandatory = false;
      this.checkremarksmandatory()
    }
    if (this.configValueDecimal == "Yes" && this.changeDueAmountDecimal) {
      let dueAmountPaymentDecimal = this.paymentForm.controls['net_receivable_amount'].value;
      if(dueAmountPaymentDecimal > 0)
      this.paymentForm.controls['net_receivable_amount'].setValue(Number(dueAmountPaymentDecimal).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
    this.paymentForm.controls['net_receivable_amount'].setValue(dueAmountPaymentDecimal);
    }
    this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
    if (event.target['checked']) {
      this.paymentForm.controls['due_authorised_by_id'].enable();
      this.navVar[this.findIndexByFieldName('remarks')].default_open = true; //6
      this.visibility.showField = true;
      this.amounts.is_due = true;
      this.visible_is_due = false
      this.getconfigforGuarantor();
      this.paymentForm.patchValue({ due_amount: this.amounts.netPayableAmount, net_receivable_amount: 0 });
      if (this.paymentForm.controls['due_amount'].value <= 0) {
        this.resetDueCheckbox();
        this.alertService.error("Due amount must be greater than zero");
      }
      this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
      console.log('due fetch api called');
      try {
        // this.baseService.getByDataSource(this.reasonTypeDiscountApi).subscribe(res => {
        //   if (res.errCode == 0) {
        //     this.responses.reasonNameData = res.resource;
        //   }
        // })
        this.getDueData();
        if (!window.location.href.includes("ipbilling") && !window.location.href.includes("dcbilling") && !window.location.href.includes("erbilling")) {
          if (this.responses.reasonNameDueData == undefined) {
            this.baseService.getByDataSource(this.reasonTypeDueApi).subscribe(res => {
              if (res.errCode == 0) {
                this.responses.reasonNameDueData = res.resource;
              }
            })
          }
        }
      } catch (e) {
        console.error('Error while fetching due', e);
      }
    } else {
      this.visibility.showField = false;
      this.amounts.is_due = false;
      this.resetGuarantor();
      this.amounts.remainingDue = Number(this.paymentForm.controls['due_amount'].value);
      this.paymentForm.patchValue({ due_amount: 0, net_receivable_amount: this.amounts.remainingDue });
      this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value);
      this.amounts.sum = 0;
      this.visible_is_due = false;
      this.showDeposit = true;
      this.show_sponsor = true;
      if (!this.paymentForm.controls['is_discount'].value || (this.paymentForm.controls['is_discount'].value && 
      (this.paymentForm.controls['type'].value == 'scheme' || 
      (this.responses && this.responses.discountResponseData[0] &&(this.responses.discountResponseData[0].workflow_stage == "notify_only" || this.responses.discountResponseData[0].workflow_stage == "otp_based"))))) {
        this.showPaymentdeails = true;
      }
      if(this.amounts && !this.amounts.is_due && this.paymentForm.controls['due_authorised_by_id'].value != ''){
        this.paymentForm.controls['due_authorised_by_id'].setValue('');
        this.paymentForm.controls['due_authorised_by_id'].disable();
        this.paymentForm.controls['due_authorised_by_name'].setValue('');
      }
      this.paymentForm.controls['due_authorised_by_id'].disable();
    }
  }

  toggleIsGuarantor(event: any) {
  if (event.target.checked) {
    this.amounts.is_guarantor = true;
  } else {
    // the composite array is only hidden by *ngIf, so its rows survive in the
    // form control and reappear on re-select - clear them with the checkbox
    this.resetGuarantor();
  }
}

  getDueData() {
    if (this.paymentForm.controls['due_amount'].value && this.paymentForm.controls['is_due'].value == true && this.paymentForm.controls['due_amount'].value != "0") {
      let s_o_r;
      if (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD Clinical Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_CLINICAL_BILLING_AUTH_CLEARANCE")){
        s_o_r = (this.dataSet.op_amount_value.patientType ? this.dataSet.op_amount_value.patientType : this.dataSet.op_amount_value.patient_details ? this.dataSet.op_amount_value.patient_details.patientType :(this.dataSet.transaction_type.split(" ")[0]).toUpperCase()) + " CLINICAL SPLIT BILL DUE"
        this.wkflow_called = true;
      }
      else if (this.dataSet && this.dataSet.transaction_type == "Pharmacy Billing" && (this.dataSet.patient_type == "IP" || (this.dataSet && this.dataSet.op_amount_value && this.dataSet.op_amount_value.orderedFrom == "IPD_PHARMACY_SPLIT_BILL_AUTH_CLEARANCE"))){
        s_o_r = "IPD PHARMACY SPLIT BILL DUE";
      }
      else{
        s_o_r = (this.dataSet.transaction_type.split(" ")[0]).toUpperCase() + " ORDER DUE"
      }
      this.dueApiSignature.args = "flow_master:due,authorization_amount:" + this.paymentForm.controls['due_amount'].value + ",source_of_request:" + s_o_r
      this.baseService.getByDataSource(this.dueApiSignature).subscribe(res => {
        if (res.errCode == 0) {
          this.responses.dueResponseData = res.resource;
        } else {
          this.responses.dueResponseData = []
          this.alertService.error(res.message);
        }
      })
    }
  }

  updatedDue() {
    this.paymentForm.controls['due_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
  }

  checkDeposit() {
    if (this.paymentForm.controls.used_deposit_amount.valid) {
      this.resetDueCheckbox(); //resetting due amount field to fill new values
      this.resetPaymentDetail(); //resetting payment details field to fill new values
      this.amounts.depositAmount = this.paymentForm.controls['used_deposit_amount'].value;
      let patientAmount = this.paymentForm.controls['final_amount'].value;
      if (this.paymentForm.controls['deposit_amount'].value < this.amounts.depositAmount) {
        this.alertService.error('Can Not Use Deposit More Than Deposit Amount. Used Deposit Resetting.', 'Invalid Use Deposit Error');
        this.paymentForm.controls['used_deposit_amount'].setValue(0);
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(patientAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
        this.amounts.depositAmount = 0;
      } else if (this.amounts.depositAmount > patientAmount) {
        this.alertService.error('Can Not Use Deposit More Than Net Payable Amount. Used Deposit Resetting.', 'Invalid Use Deposit Error');
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(patientAmount).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
        this.paymentForm.controls['used_deposit_amount'].setValue(0);
        this.amounts.depositAmount = 0;
      } else if (this.amounts.depositAmount == null || this.amounts.depositAmount == '' || this.amounts.depositAmount == undefined) {
        this.amounts.netPayableAmount = (patientAmount - this.paymentForm.controls['used_deposit_amount'].value);
        this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
        this.paymentForm.controls['used_deposit_amount'].setValue(0);
        this.amounts.depositAmount = 0;
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      } else if (this.amounts.depositAmount != 0) {
        this.amounts.netPayableAmount = (patientAmount - this.paymentForm.controls['used_deposit_amount'].value);
        this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
    }
  }

  validateDiscount(event: any) {
   // setTimeout(() => {
    this.schm_rmvd = false;
    this.scheme_idd = event.id;
    this.scheme_selected = true;
    if (this.paymentForm.controls['type'].value == 'scheme') {
      let scheme = this.paymentForm.controls['scheme'].value;
      if (scheme != undefined || scheme != '') {
        let schemeName = this.responses.schemeResponse.find(val => {
          return val.id == scheme;
        });
        this.scheme_type = schemeName?.scheme_type;
        this.paymentForm.controls['scheme_name'].setValue(schemeName ? schemeName.scheme_name : "");
      }
      this.amounts.override_scheme = false;
      <any>this.paymentForm.controls['override_scheme'].setValue(false);
      this.visibility.disableDiscountValue = false;
      if (event.isManual && this.appService.getApplication() == "optical"){
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, scheme_name: (event && event.alldata && event.alldata.scheme_name) ? event.alldata.scheme_name : "", schemeId: scheme, scheme_type : this.scheme_type ,'override_scheme': false });
      }
      if(this.appService.getApplication() != "optical"){
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, scheme_name: (event && event.alldata && event.alldata.scheme_name) ? event.alldata.scheme_name : "", schemeId: scheme,scheme_type : this.scheme_type,'override_scheme': false });
      }
    } else if (this.paymentForm.controls['type'].value == 'direct') {
      if (this.paymentForm.controls['discount_on'].value == 'service_item') {
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, typeToggled: true });
      }
      if (this.paymentForm.controls['discount_on'].value == 'bill') {
        this.paymentForm.controls['discount_value'].setValue('');
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0, typeToggled: true, is_manual_checked : true });
      }
    }
    this.populateDisc();
    if (event == 'percentage' && this.paymentForm.controls['discount_value'].value > 100) {
      this.paymentForm.controls['discount_value'].markAsDirty();
    }
    else {
      this.paymentForm.controls['discount_value'].setValidators([Validators.required, Validators.maxLength(18), Validators.min(0)]);
    }
 // }, 500);

  }
  validateCharges(event: any){
    // this.visibility.showField = true;
    if (event && event.id != undefined && event.alldata.item_name != undefined) {
      this.deliveryCharges.emit({'facility_id': event.alldata.facility_id,'service_name': event.alldata.item_name,'service_code': event.alldata.item_code,'id': event.alldata.id,'discount_on': this.dataSet.discount_on,'discount': this.dataSet.discount_value});
    }
    // else if(event.text!=''){
    //   this.visibility.schemeVisible = true;
    // }
    // this.visibility.schemeVisible = true;
  }
  itemCharges(event: any){
    if (event && event.target && event.target['checked'] ) {
      this.navVar[this.findIndexByFieldName('delivery_charges')].default_open = true; //7
      this.visibility.disableFields = false;

    }
    else if (event.target['checked']==false) {
      this.visibility.disableFields = true;
      this.paymentForm.controls['item_name'].reset('');
      this.deliveryCharges.emit();
    }
  }
  validateChargesdeselect(event: any){
    if (event.id == undefined) {
      this.deliveryCharges.emit();
      // this.visibility.showField = true;
    }
  }
  validateDiscountdeselect(event: any) {
    this.schm_rmvd = true;
    this.scheme_idd = event.id;
    this.scheme_selected = true;
    if (this.paymentForm.controls['type'].value == 'scheme') {
      let scheme = this.paymentForm.controls['scheme'].value;
      if (scheme != undefined || scheme != '') {
        let schemeName = this.responses.schemeResponse.find(val => {
          return val.id == scheme;
        });
        this.paymentForm.controls['scheme_name'].setValue(schemeName ? schemeName.scheme_name : "");
      }
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, schemeId: scheme });
    } else if (this.paymentForm.controls['type'].value == 'direct') {
      if (this.paymentForm.controls['discount_on'].value == 'service_item') {
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, typeToggled: true });
      }
      if (this.paymentForm.controls['discount_on'].value == 'bill') {
        this.paymentForm.controls['discount_value'].setValue('');
        this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0, typeToggled: true });
      }
    }
    this.populateDisc();
    if (event == 'percentage' && this.paymentForm.controls['discount_value'].value > 100) {
      this.paymentForm.controls['discount_value'].markAsDirty();
    }
    else {
      this.paymentForm.controls['discount_value'].setValidators([Validators.required, Validators.maxLength(18), Validators.min(0)]);
    }
  }
  reasonMasterNameForDiscount(event) {
    if (this.responses && this.responses.reasonNameDiscountData) {
      let reasonDiscountData = this.responses.reasonNameDiscountData.find(val => {
        if(event && event.target){
          return val.name == event.target.value;
        }
      });
      if (event)
        if(reasonDiscountData){
          this.paymentForm.controls['discount_reason'].setValue(reasonDiscountData.name);
        }
    }
  }

  setBillingReasonDatasource(transactionType) {
    let reasonTypeId = '';
    // op_bill and op_pharmacy_bill reasons are combined under billing_reason
    if (transactionType == 'OP Billing' || transactionType == 'OP Edit Billing' || transactionType == 'Pharmacy Billing')
      reasonTypeId = 'billing_reason';
    if (!reasonTypeId || this.remarkReasonTypeMulti.datasource?.args?.endsWith(reasonTypeId))
      return;
    this.remarkReasonTypeMulti.datasource = {
      "application": "facility-management",
      "resource": "facility_master",
      "query_id": "getReasonNameBasedOnReasonType",
      "args": "facility_master_type:REASON,reasontype_id:" + reasonTypeId,
      "key": "id"
    };
  }

  showBillingReason() {
    return this.dataSet != undefined && (this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'OP Edit Billing' || this.dataSet.transaction_type == 'Pharmacy Billing');
  }

  isBillingReasonMissing() {
    let value = this.paymentForm?.controls?.['billing_reason']?.value;
    return this.billing_reason_mandatory_config_value && this.showBillingReason() && (value == null || (typeof value == 'string' && value.trim() == '') || (Array.isArray(value) && value.length == 0));
  }

  reasonMasterNameForDue(event) {
    if (this.responses && this.responses.reasonNameDueData) {
      let reasonDueData = this.responses.reasonNameDueData.find(val => {
        if(event && event.target){
          return val.name == event.target.value;
        }
      });
      if (event)
        if(reasonDueData){
          this.paymentForm.controls['due_reason'].setValue(reasonDueData.name);
        }
    }
  }


  schemeClicked(event) {
    let data = {
      args: "id:" + this.scheme_idd,
      resource: 'scheme_detail_bill',
      action: 'view',
      query_id: 'GET_BY_ID',
      application: 'facility-management'

    }

    this.baseService.modalService.dialogService.open(BillingpopupComponent, { size: DialogModalSize.Lg, data }).afterClosed.subscribe(data => { }, err => { })
  }

  toggleFieldsOnScheme(event) {
    if(this.paymentForm.controls['scheme'].value && this.dataSet.transaction_type == "optical billing")
    this.paymentForm.controls['scheme'].setValue("")
    this.schm_rmvd = true;
    console.log("inside again 1")
    this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value, toggled: true, is_manual_checked : true });
    let tax = 0;
    let totalAmount = this.paymentForm.controls['total_amount'].value;
    this.paymentForm.patchValue({ discount: 0, discount_value: 0, net_amount: totalAmount, net_receivable_amount: this.paymentForm.controls['final_amount'].value })
    this.visibility.disableDiscountValue = false;
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
    this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    if (event.target.value == 'scheme') {
      this.addedresourceInfo()
      this.visibility.discountFieldVisible = false;
      if (this.dataSet.transaction_type == "OP Billing" || this.dataSet.transaction_type == "Optical Billing" || this.dataSet.transaction_type == 'OP Edit Billing') {
        this.schemeresource = {
          "datasource": {
            "application": "facility-management",
            "resource": "scheme_detail",
            "query_id": "GET_SCHEME_DETAILS",
            "args": "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + ((this.dataSet && this.dataSet.payer) ? this.dataSet.payer : '')
          },
          question: {
            defaultsetting: {
              "singleSelection": true,
              "checkBoxRequired": false,
              "closeDropDownOnSelection": true,
              "apliCall": false
            },
            "req_keys": [
              "id",
              "scheme_name"
            ],
            getterKey: 'id',
            getterValue: 'scheme_name',
            key: "id"
          },
          controls: {
            due_reason: {
              value: ""
            }
          },
          defaultsetting: {
            "singleSelection": true,
            "checkBoxRequired": false,
            "closeDropDownOnSelection": true,
            "apliCall": false
          }
        }
      }
      this.visibility.schemeVisible = true;
      if (!this.paymentForm.controls['scheme'].value || (this.dataSet.scheme_id == "" && !this.dataSet.scheme_discount_applicable))
        this.paymentForm.controls['scheme'].setValue('')
      if(this.paymentForm.controls['type'].value == "scheme" && this.paymentForm.controls['discount_authorized_by'].value){
        this.paymentForm.controls['discount_authorized_by'].setValue('')
        this.amounts.otp_required = false     
      }
      try {
        console.log("Data ", this.dataSet);
        this.schemeApiSignature['args'] = "";
        if (this.patientInfo != undefined && this.patientInfo.uhId != undefined) {
          if (this.dataSet && this.dataSet.transaction_type && this.dataSet.transaction_type == "Pharmacy Billing") {
            this.schemeApiSignature['args'] = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + this.dataSet.payerID;
          } else if (this.dataSet && this.dataSet.transaction_type && (this.dataSet.transaction_type == "OP Billing" || this.dataSet.transaction_type == 'OP Edit Billing')) {
            this.schemeApiSignature['args'] = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender + ",payer:" + this.dataSet.payer;
            if (this.appService.getUniversalConfig('multi_care_type')) {
              this.schemeApiSignature['args'] += ",care_type:" + this.appService.getDynamicFunctions("getCurrentCareType")
            }
          } else {
            this.schemeApiSignature['args'] = "uhId:" + this.patientInfo.uhId + ",patient_type:" + this.patientInfo.patient_type + ",gender:" + this.patientInfo.gender;
          }

        }
        // if(this.dataSet.orderedFrom == "Optical Order"){
        //   this.schemeApiSignature['args'] += ",applicable_on:CUSTOM_SCHEME"
        // }
        this.baseService.getByDataSource(this.schemeApiSignature).subscribe(res => {
          console.log('scheme api data ==>>', res);
          if (res.errCode == 0 && res.count > 0) {
            this.responses.schemeResponse = res.resource;
          }
        })
      } catch (e) {
        console.error('Error => ', e);
      }
    } else {
      if (event.target.value == 'service_item') {
        this.visibility.disableDiscountValue = true;
      }
      this.visibility.discountFieldVisible = true;
      this.visibility.schemeVisible = false;
    }
  }


  dueAuthorizeName(event) {
    this.dueName = this.responses.dueResponseData.find(val => {
      return val.userId == event.target.value;
    });
    if (this.dueName != undefined)
      this.paymentForm.controls['due_authorised_by_name'].setValue(this.dueName.userName);
    if (this.dueName.workflow_stage == "otp_based")
      this.authorizationAction('due', this.paymentForm.controls['due_authorised_by_id'].value, this.paymentForm.controls['due_authorised_by_name'].value, this.dueName);
    if(this.dueName.workflow_stage == "single_stage" && this.paymentForm.controls['is_due'].value==true && (this.paymentForm.controls['used_deposit_amount'].value!=0 ||this.paymentForm.controls.is_sponsor_fund_applied.value)){
      this.resetDepositCheckbox();
      if(this.appService.getApplication() == 'pharmacy')
      this.toggleIsSponsorFund("single_multi_stage");
    }
    if (this.dueName.workflow_stage == "single_stage" || this.dueName.workflow_stage == "multi_stage") {
      this.showDeposit = false; this.showPaymentdeails = false;
      this.show_sponsor = false;
      if (this.paymentForm.controls['payment_detail'].value && this.paymentForm.controls['payment_detail'].value.length != 0) {
        this.resetDueCheckbox(); this.resetDiscountCheckbox(); this.resetPaymentDetail();
        // this.resetRealDiscountCheckbox();
        // this.showPaymentdeails = true;
      }
    }
  }

  resetDepositCheckbox() {
    this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['due_amount'].value+this.paymentForm.controls['used_deposit_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
  }
  
  checkremarksmandatory() {
    if(this.remarksMandatory){
      if ((this.dueName && (this.dueName.workflow_stage == "single_stage" || this.dueName.workflow_stage == "multi_stage")) || (this.discountData && (this.discountData.workflow_stage == "single_stage" || this.discountData.workflow_stage == "multi_stage"))) {
        return true
      } else {
        return false
      }
    } else{
      return false
    }    
  }

  submit() {
    console.log('userdata ==>>', this.paymentForm.getRawValue());
  }

  checkDuplicatePaymentMode() {
    this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_100', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0 && result.resource.length > 0) {
          this.duplicatePaymentConfigResult = result.resource[0].config_value
        }
      });
  }
  openCashPopup(event) {
    let data = {
      da: event.items, index: event.index

    }
    this.smartModalService.open(CashDenominationComponent, data, "", ModalSize.Sm, "hide").subscribe(
      result => {
        const key = "cash_DenData";

        let existingData = sessionStorage.getItem(key);

        let parsedData = existingData ? JSON.parse(existingData) : {};

        parsedData[result.result.index] = result.result;

        sessionStorage.setItem(key, JSON.stringify(parsedData));
      })
  }
  OnPaymentAdd(event) {
    PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent);
    if (event.action == "info") {
      this.openCashPopup(event);

    }
    else {
    if (this.paymentForm.controls['net_receivable_amount'].value == 0) {
      this.calledAction = event.action;
    }
    else{
      this.calledAction = "";
    }
    let used_deposit_amount = 0
    if(this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['deposits'] && this.paymentForm.controls['is_used_deposit'] && this.paymentForm.controls['is_used_deposit'].value == true && this.paymentForm.controls['used_deposit_amount'].value == 0){
      this.paymentForm.controls['deposits'].value.forEach(element => {
        used_deposit_amount += element.used_deposit_amount
      });
      this.paymentForm.controls['used_deposit_amount'].setValue(used_deposit_amount);
    }
    if(event.action == "edit" && this.amounts.is_due){
      this.resetDueCheckbox();
     }
    if (event.items != undefined && event.items.length > 0) {
      if (this.duplicatePaymentConfigResult && this.duplicatePaymentConfigResult == 'no') {
        for (let i = 0; i < event.items.length - 1; i++) {
          let element = event.items[i];
          if (element['payment_mode'] == event.items[event.items.length - 1].payment_mode) {
            this.compositeArrayComponent.removeRow(event.items.length - 1);
            this.alertService.error('Same payment mode can not accept multiple times');
            return;
          }
        };
      }
      else if (this.duplicatePaymentConfigResult && this.duplicatePaymentConfigResult == 'yes') {
        let i = 0
      const transactionMap = new Map();
        if (event.items && event.items.length > 0)
          for (const element of event.items) {
            if (element.payment_mode == 'Cash') {
              i = i + 1
              this.adding = i
            }
            else {
              const txnNo = (element.transaction_no || element.request_transaction_no || '').toString().trim();
              const bankId = (element.bank_id || element.bank_code || '').toString().trim();
              const key = `${txnNo}_${bankId}`;
              if (txnNo && bankId && transactionMap.has(key)) {
                this.compositeArrayComponent.removeRow(event.items.length - 1);
                this.alertService.error('Duplicate bank name and transaction number combinations are not allowed.');
                return;
              }
              transactionMap.set(key, true);
  }
}
        if (this.adding && this.adding > 1) {
          this.compositeArrayComponent.removeRow(event.items.length - 1);
          this.alertService.error('Same payment mode can not accept multiple times');
          return;
        }
      }
      if (event.items[event.items.length - 1].payment_mode_id == "pos" && event.items[event.items.length - 1].integrated_pos_machine == "integrated_pos" && event.action != 'delete') {
        let deviceID = this.appService.readCookie('device_id');
        let resource = {
          deviceId: deviceID,
          amount: event.items[event.items.length - 1].received_amount,
          uhId: this.patientInfo.uhId,
          pos_option_code: event.items[event.items.length - 1].pos_option_code,
          pos_option_name: event.items[event.items.length - 1].pos_option_name
        }
        this.baseService.action(resource, 'POS_PAYMENT_REQUEST', 'payment-gateway', 'ui_gateway_response').subscribe(response => {
          console.log("Resopnse from payment gateway", response)
          if (response && response.resource && response.resource[0] && response.resource[0].extra_data) {
            this.pos_transaction_id = response.resource[0].extra_data.gateway_transactionId
            this.paymentForm.controls['payment_detail'].value[this.paymentForm.controls['payment_detail'].value.length - 1].transaction_no = response.resource[0].extra_data.kx_transactionId
            this.paymentForm.controls['payment_detail'].value[this.paymentForm.controls['payment_detail'].value.length - 1].kx_transaction_no = response.resource[0].extra_data.kx_transactionId
          }
        });
      }
    }
    this.amounts.sum = 0;
    if (this.configValueDecimal == "Yes") {
      if (this.paymentForm.controls['net_receivable_amount'].value) {
        this.amounts.netPayableAmount = Number(this.paymentForm.controls['net_receivable_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2);
      }
    } else {
      this.amounts.netPayableAmount = this.paymentForm.controls['net_receivable_amount'].value;
    }
    if (this.paymentForm.controls['net_receivable_amount'].value < 0)
      this.paymentForm.controls['net_receivable_amount'].setValue(0)
    this.amounts.paidAmount = [];
    if (event.type !== false && event.action != 'delete') {
      if (event.items != undefined && event.items.length > 0) {
        this.addedAmount = event.items[event.items.length - 1].received_amount;
        for (let i = 0; i < event.items.length; i++) {
          let element = event.items[i];
          if (element['received_amount'] == 0) {
            this.compositeArrayComponent.removeRow(event.items.length - 1);
            this.alertService.error('Amount added must be greater than zero');
            this.calledAction = "";
            return;
          }
          this.amounts.sum += Number(element.received_amount);
        }
      }
      this.amounts.paymentData = this.paymentForm.controls['payment_detail'].value;
      if (event.action == 'ADD') {
        if (this.paymentForm.controls['net_receivable_amount'].value == 0) {
          this.compositeArrayComponent.removeRow(event.items.length - 1);
          this.alertService.error('Amount Paid More Than Net Payable Amount');
          this.paymentForm.controls['net_receivable_amount'].setValue(0);
          this.calledAction = ""
          return;
        }
      }
      if (this.amounts.paymentData != null) {
        for (let entry of this.amounts.paymentData)
          this.amounts.paidAmount.push(entry.received_amount);

        if (event.action == 'edit') {
          let patientAmount = this.paymentForm.controls['final_amount'].value;
          if (this.amounts.sum > patientAmount) {
            this.compositeArrayComponent.removeRow(this.amounts.paymentData.length - 1);
            this.alertService.error('Amount Paid More Than Net Payable Amount', 'Excess Payment Added');
            this.calledAction = ""
          } else {
            if (this.amounts.is_due) {
              let patientAmount = this.paymentForm.controls['final_amount'].value - this.paymentForm.controls['authorised_amount'].value;
              this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['net_receivable_payer_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));

              if (this.configValueDecimal == "Yes") {
                let dueAmountForOP = this.paymentForm.controls['due_amount'].value;
                dueAmountForOP = Math.abs(dueAmountForOP.toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
                this.paymentForm.controls['due_amount'].setValue(Number(dueAmountForOP).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
                this.amounts.due_amount = this.paymentForm.controls['due_amount'].value;
              } else {
                this.amounts.due_amount = this.paymentForm.controls['due_amount'].value;
              }

              if (this.amounts.due_amount <= 0) {
                this.resetDueCheckbox();
              }
              if (this.configValueDecimal == "Yes") {
                let subtractedAmountForDecimalConfig: any;
                subtractedAmountForDecimalConfig = patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value;
                this.amounts.netPayableAmount = subtractedAmountForDecimalConfig.toFixed(2) - this.paymentForm.controls['due_amount'].value;
                this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
                if(this.amounts.netPayableAmount > 0)
                this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              else
              this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
              } else {
                this.amounts.netPayableAmount = (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
                this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
                if(this.amounts.netPayableAmount > 0)
                this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              else
              this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
              }

            } else {
              this.paymentForm.controls['due_amount'].setValue(0);
              this.amounts.netPayableAmount = (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
              this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              if(this.amounts.netPayableAmount > 0)
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
            else
            this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
            }
          }
        } else {
          if (this.amounts.is_due) {
            this.amounts.due_amount = this.paymentForm.controls['due_amount'].value;
            if (this.paymentForm.controls['due_amount'].value >= this.amounts.paidAmount[this.amounts.paidAmount.length - 1]) {
              let patientAmount = this.paymentForm.controls['final_amount'].value;
              this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              if (this.amounts.due_amount <= 0) {
                this.resetDueCheckbox();
              }
              this.amounts.netPayableAmount = (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
              this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              if(this.amounts.netPayableAmount > 0)
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
            else
            this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
            }
            else {
              if (this.amounts.due_amount <= this.amounts.paidAmount[this.amounts.paidAmount.length - 1]) {
                this.compositeArrayComponent.removeRow(this.amounts.paymentData.length - 1);
                this.alertService.error('Amount Paid More Than Net Payable Amount', 'Excess Payment Added');
                this.calledAction = ""
              }
              this.paymentForm.controls['net_receivable_amount'].setValue(0);
            }
          } else {
            this.paymentForm.controls['due_amount'].setValue(0);
            if (Number(this.amounts.netPayableAmount) >= Number(this.amounts.paidAmount[this.amounts.paidAmount.length - 1])) {
              let patientAmount = 0;
                patientAmount = this.paymentForm.controls['final_amount'].value;
              this.amounts.netPayableAmount = this.is_advance_checked ? this.paymentForm.controls.net_receivable_amount.value - this.addedAmount : this.paymentForm.controls.is_sponsor_fund_applied.value == true ? (patientAmount - this.amounts.sum - this.paymentForm.controls['due_amount'].value): (patientAmount - this.amounts.sum - this.paymentForm?.controls?.used_deposit_amount?.value - this.paymentForm.controls['due_amount'].value);
              this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              if (this.configValueDecimal == "Yes") {
                let netPayableAmountForDecimal = Math.abs(this.amounts.netPayableAmount);
                this.amounts.netPayableAmount = netPayableAmountForDecimal.toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2);
                this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
              }
              if(this.amounts.netPayableAmount > 0)
              this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              else
              this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
            }
            else {
              if (this.amounts.paymentData.length > 0) {
                this.compositeArrayComponent.removeRow(this.amounts.paymentData.length - 1);
                this.alertService.error('Amount Paid More Than Net Payable Amount', 'Excess Payment Added');
                this.calledAction = ""
              }
            }
          }
        }
      }
    }
    if(this.paymentForm.controls && this.paymentForm.controls['net_receivable_amount'].value > 0){
      this.getDueData()
    }
  }
  }

  removeDuplicatePaymentDetails(array) {
    return array.filter((value, index) => array.indexOf(value) === index);
  }

  resetPaymentDetail() {
    this.paymentForm.controls['payment_detail'].reset();
    let sum = 0;
    if (this.paymentForm.controls['payment_detail'].value != null) {
      this.paymentForm.controls['payment_detail'].value.forEach(element => {
        sum += element.received_amount;
      });
    }
    this.paymentForm.controls['net_receivable_amount'].setValue(this.paymentForm.controls['final_amount'].value - sum);
    this.amounts.sum = 0;
    this.updatedDue();
  }

  populateDisc(flag?) {
    this.wkflow_called = false;
    if (this.appService.getApplication() == "optical" && this.paymentForm.controls['type'].value == 'scheme' && this.dataSet && this.dataSet.op_amount_value) {
      if(this.dataSet.op_amount_value.discount > 0)
      this.paymentForm.controls['discount_value'].setValue(Number(this.dataSet.op_amount_value.discount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    else
    this.paymentForm.controls['discount_value'].setValue(this.dataSet.op_amount_value.discount);
    }
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
    if (flag != undefined) { this.paymentForm.controls['discount_authorized_by'].setValue(""); this.paymentForm.controls['discount_authorized_by_id'].setValue(""); }
    this.resetDueCheckbox(); //resetting due amount field to fill new values
    this.resetPaymentDetail(); //resetting payment details field to fill new values
    this.resetDiscountCheckbox()
    console.log("netPayable populateDisc - ", this.amounts.netPayableAmount);
    if (this.paymentForm.controls['discount_value'].value == '' && this.paymentForm.controls['type'].value != 'scheme') {
      this.paymentForm.controls['discount_value'].setValue(0);
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0 });
    }
    let type = this.paymentForm.controls['discount_type'].value;
    let totalAmt = Number(this.paymentForm.controls['total_amount'].value);
    let netAmt = Number(this.paymentForm.controls['final_amount'].value);
    this.amounts.discountValue = this.paymentForm.controls['discount_value'].value;
    let discOnAmt = this.amounts.discountValue;
    let tax = 0;
    if (this.amounts.discountValue > 0) {
      if(type === ""){
        this.alertService.error('Please fill discount type first');
        this.paymentForm.controls['is_discount'].setValue(false);
        this.amounts.is_discount = false;
      }
      if (type == 'percentage') {
        if (this.amounts.discountValue <= 100) {
          let disc = +((totalAmt * this.amounts.discountValue) / 100).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2);
          this.paymentForm.patchValue({ discount: disc, net_amount: totalAmt - disc, net_receivable_amount: totalAmt - disc + tax });
          this.amounts.netPayableAmount = totalAmt - discOnAmt + tax;
          this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: discOnAmt });
          this.bindDropDownsFormExternalResources(); //line for checking again discount
        }
        else {
          this.alertService.error('Invalid Discount entered. Resetting', 'Reset')
          this.paymentForm.patchValue({ discount_value: 0, discount: 0, net_amount: totalAmt, net_receivable_amount: totalAmt-this.paymentForm.controls['authorised_amount'].value + tax, final_amount:totalAmt-this.paymentForm.controls['authorised_amount'].value + tax});
        }
      } else {
        if (this.amounts.discountValue <= netAmt) {
          if (type == 'amount') {
            this.paymentForm.patchValue({ discount: discOnAmt, net_amount: totalAmt - discOnAmt, net_receivable_amount: totalAmt - discOnAmt + tax });
            this.paymentForm.controls['discount'].setValue(this.amounts.discountValue);
          } else {
            this.paymentForm.patchValue({ discount: discOnAmt, net_amount: totalAmt - discOnAmt, net_receivable_amount: totalAmt - discOnAmt + tax });
          }
          this.amounts.netPayableAmount = totalAmt - discOnAmt + tax;
          this.bindDropDownsFormExternalResources(); //line for checking again discount
          // Now working code is
          if (this.paymentForm.controls['type'].value == 'scheme' && this.paymentForm.controls['scheme'].value) {
            this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, scheme_name: this.paymentForm.controls['scheme_name'].value, schemeId: this.paymentForm.controls['scheme'].value, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });
          } else {
            if(this.dataSet && this.dataSet.transaction_type && this.dataSet.transaction_type == "optical billing")
              this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value, discount_authorized_by_id: this.paymentForm.controls['discount_authorized_by'].value, discount_authorized_by_name: this.paymentForm.controls['discount_authorized_by_name'].value});
            else 
            this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value, is_manual_checked : true });
          }

          //Earlier this was written 
          // this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });
        }
        else if (this.paymentForm.controls['type'].value == 'direct') {
          this.alertService.error('Invalid Discount entered. Resetting', 'Reset')
          this.paymentForm.patchValue({ discount_value: 0, discount: 0, net_amount: totalAmt, net_receivable_amount: totalAmt-this.paymentForm.controls['authorised_amount'].value + tax,  final_amount:totalAmt-this.paymentForm.controls['authorised_amount'].value + tax});
        }
      }
    }
    else
      this.paymentForm.patchValue({ discount: (this.paymentForm.controls['type'].value == 'scheme'?this.paymentForm.controls.discount.value :0), net_amount: totalAmt, net_receivable_amount: this.paymentForm.controls['final_amount'].value });
  }

  discountauthorisedName(event) {
    if(this.dataSet!=undefined && this.dataSet.transaction_type == 'OP Edit Billing' && this.disableEditBillButton){
      this.createDisable = this.disableEditBillButton;
    }
    this.time_for_otp_reset = true
    this.discountData = this.responses.discountResponseData.find(val => {
      return val.userId == event.target.value;
    });
    this.paymentForm.controls['discount_authorized_by_name'].setValue(this.discountData.userName);
    this.paymentForm.controls['discount_authorized_by_id'].setValue(this.discountData.userId);
    if (this.paymentForm.controls.type.value == 'direct' && this.discountData.workflow_stage == "otp_based")
      this.authorizationAction('discount', this.paymentForm.controls['discount_authorized_by'].value, this.paymentForm.controls['discount_authorized_by_name'].value, this.discountData);
    if (this.discountData.workflow_stage == "single_stage" || this.discountData.workflow_stage == "multi_stage") {
      if(this.dataSet.orderedFrom == "Optical Order")
        this.is_opt_sm_stage = true;
      else
      this.is_opt_sm_stage = false;
      this.showDeposit = false; this.showPaymentdeails = false;
      if (this.paymentForm.controls['payment_detail'].value && this.paymentForm.controls['payment_detail'].value.length != 0) {
        this.resetDueCheckbox(); this.resetDiscountCheckbox(); this.resetPaymentDetail();
        // this.resetRealDiscountCheckbox();
        // this.showPaymentdeails = true;
      }
    }
    if (this.discountData.workflow_stage == "notify_only")
      this.visibility.disableField = true;
    if (this.paymentForm.controls.discount_on.value == 'service_item' && this.discountData.workflow_stage == "notify_only") {
      this.authoriseDetail.emit({ 'discount_on': this.paymentForm.controls.discount_on.value });
    }
  }
  authorizationAction(type, id, name, authorize_value?) {
    if (type == 'discount')
      this.amounts.otp_verified = false;
    else if (type == 'due')
      this.amounts.otp_verified_due = false;
    this.loader.showSpinner();
    if (type == 'discount' && !authorize_value)
      authorize_value = this.discountData
    if (type == 'due' && !authorize_value)
      authorize_value = this.dueName
    let Arr = [];
    Arr.push({ "id": authorize_value.id, "user_role_name": authorize_value.user_role_name, "userName": authorize_value.userName, "userId": authorize_value.userId, "login_id": authorize_value.login_id, "contact_no": authorize_value.contact_no, "email_address": authorize_value.email_address, "active_period": authorize_value.active_period })
    // // let result = {
    //   "authorized_by_id": id,
    //   "authorized_by": name,
    //   "uhId": this.patientInfo.uhId,
    //   "discount_type": this.paymentForm.controls['discount_on'].value,
    //   "transaction_type": this.dataSet['transaction_type'],
    //   "authorized_type": type,
    //   "patient_type": this.dataSet.patient_type,
    //   "total_amount": this.paymentForm.controls['total_amount'].value,
    //   "final_amount": this.paymentForm.controls['net_receivable_amount'].value,
    // }
    if (type == 'discount') {
      authorize_value["flow_amount"] = this.paymentForm.controls['discount'].value;
      authorize_value['op_amount'] = this.dataSet.op_amount_value;
      authorize_value['authority_checkpoints'] = Arr
    } else if (type == 'due') {
      authorize_value["flow_amount"] = this.paymentForm.controls['due_amount'].value;
      authorize_value['op_amount'] = this.dataSet.op_amount_value;
      authorize_value['authority_checkpoints'] = Arr
    }
    if (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD Clinical Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_CLINICAL_BILLING_AUTH_CLEARANCE")){
      let patientadmissionid = sessionStorage.getItem('admissionidip');
      authorize_value["admissionId"] = patientadmissionid;
      authorize_value["uhId"] = authorize_value.op_amount.uhId
      let billing_discount_data = {
        "uhId" :  authorize_value.uhId,
        "admissionId" : authorize_value.admissionId,
        "transaction_type" : "IP Billing",
        "discount_type" : authorize_value.op_amount.discount_on,
        "authorized_type" : "discount",
        "patient_type" : authorize_value.op_amount.patient_type,
        "total_amount" : authorize_value.op_amount.total_amount,
        "final_amount" : authorize_value.op_amount.final_payable,
        "authorized_amount" : authorize_value.op_amount.discount_value,
        "authority_checkpoints" : authorize_value.authority_checkpoints,
        "flow_master" : authorize_value.flow_master,
        "source_of_request" : authorize_value.source_of_request,
        "workflow_stage" : authorize_value.workflow_stage,
        "flow_amount" : authorize_value.flow_amount,
      }
      if(type == 'discount'){
        billing_discount_data['authorized_by_id'] = this.discountData.userId
        billing_discount_data['authorized_by'] = this.discountData.userName
      }
      if(type == 'due'){
        billing_discount_data['authorized_by_id'] = this.dueName.userId
        billing_discount_data['authorized_by'] = this.dueName.userName
      }
      authorize_value['billing_discount'] = billing_discount_data
    }
    if (id != "" && ((this.dueName && this.dueName.workflow_stage == "otp_based") || (this.discountData && this.discountData.workflow_stage == "otp_based")) && ((this.discountData && this.discountData.otp_required) || (this.dueName && this.dueName.otp_required))) {
      this.baseService.action(authorize_value, 'ADD_AUTHORITY_CLEARANCE', 'billing', 'authority_clearance').subscribe(
        (data: any) => {
          console.log("Response from ADD_DISCOUNT_AUTHORITY ", data);
          if (data.errCode == 0 && data.resource.length > 0) {
            if (type == 'discount') {
              this.otp_id_discount = data.resource[0].id
              this.amounts.otp_required = data.resource[0].isOtp_required;
              if (data.resource[0].isOtp_required != true) {
                this.visibility.disableField = true;
              }
              else {
                this.otp_visibility = true
              }
              if (this.paymentForm.controls.discount_on.value == 'service_item') {
                this.authoriseDetail.emit({ 'discount_on': this.paymentForm.controls.discount_on.value });
              }
              this.paymentForm.controls['otp'].reset()
            } else if (type == 'due') {
              this.otp_id_due = data.resource[0].id
              this.amounts.otp_required_due = data.resource[0].isOtp_required;
              if (data.resource[0].isOtp_required != true) {
                this.visible_is_due = false
              }
              else {
                this.visible_is_due = true
              }
              this.paymentForm.controls['otp_due'].reset()
            }
            if (this.amounts.otp_required || this.amounts.otp_required_due) {
              clearTimeout(this.otptimeout);
              this.time_for_otp_reset = false
              this.countdown(30);
            }
            else {
              this.time_for_otp_reset = true
            }
          } else {
            this.time_for_otp_reset = true
            if (type == 'discount') {
              this.paymentForm.controls['discount_authorized_by'].reset('');
              this.paymentForm.controls['discount_authorized_by_id'].reset('');
              this.paymentForm.controls['discount_value'].reset(0);
              this.visibility.disableField = false;
            }
            if (type == 'due') {
              this.paymentForm.controls['due_authorised_by_id'].reset('');
            }
            this.otp_visibility = false
            // this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0, toggled: true });
            this.alertService.error(data.message);
          }
          this.loader.hideSpinner();
        });
    }
    else {
      this.loader.hideSpinner();
      this.amounts.otp_required = false;
      this.otp_visibility = false
      if (type == "due")
        this.amounts.otp_required_due = false
    }
  }
  countdown(x) {
    if (this.time_for_otp_reset) {
      return
    }
    if (x === 0) {
      this.amounts.timer = x;
      return;
    }
    this.otptimeout = setTimeout(() => { this.amounts.timer = x; this.countdown(--x); }, 1000)
    return this.otptimeout;
  }

  checkOTP(event, type, id, name) {
    console.log("Event is ", event.target.value);
    this.loader.showSpinner();
    let result = {
      'otp': event.target.value
    }
    if (type == 'discount')
      result['id'] = this.otp_id_discount
    if (type == 'due')
      result['id'] = this.otp_id_due
    this.baseService.action(result, 'VERIFY_OTP', 'billing', 'authority_clearance').subscribe(
      (data: any) => {
        console.log("Response from VERIFY_OTP ", data);
        if (data.errCode == 0 && data.resource.length > 0) {
          if (type == 'discount')
            this.amounts.otp_verified = true;
          else if (type == 'due')
            this.amounts.otp_verified_due = true;
          this.alertService.success("OTP Verified")
          if(this.formService && this.formService.blockMapping && this.formService.blockMapping[8])
          this.formService.blockMapping[8]['default_open'] = true;
          this.visibility.disableField = true
        } else {
          this.visibility.disableField = false
          this.paymentForm.controls['otp'].setValue('');
          if (type == 'discount')
            this.amounts.otp_verified = false;
          else if (type == 'due') {
            this.paymentForm.controls['otp_due'].setValue('');
            this.amounts.otp_verified_due = false;
          }
          this.alertService.error(data.message);
        }
        this.loader.hideSpinner();
      });
  }

  onApprovalDocumentUpload(event: any) {
    if (event && event.data && event.data.documentId) {
      this.approvalDocument = { document_id: event.data.documentId, document_name: event.data.documentName };
    }
  }
  createBill(event,printType?: string) {
    if (event == 'approve_request' && (!this.validateCharityValidity() || !this.validateCharityIncome()))
      return;
    if (this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['used_deposit_amount'] && this.paymentForm.controls['used_deposit_amount'].value > 0 && this.paymentForm.controls['used_deposit_amount'].status == "INVALID")
    {
    this.alertService.error("Please enter valid Used Deposit Amount.");
    return;
    }
    if (this.dataSet) {
      // this.createDisable = true;
      if(this.dataSet.transaction_type == 'Pharmacy Billing' || this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'OP Edit Billing') {
        this.createDisable = false;
      }
      else {
        setTimeout(() => {
          this.createDisable = false;
        }, 3000)
      }
    }
    else
      this.createDisable = true;
    if (this.paymentForm.controls['is_discount'].value) {
      if (this.paymentForm.controls['type'].value != 'scheme' && this.discount_remark_mandatory_config_value) {
        if (this.paymentForm.controls['discount_reason'].value == "" || this.paymentForm.controls['discount_reason'].value == undefined) {
          this.alertService.error("Please select Discount Reason");
          this.createDisable = false;
          return;
        }
      }
    }

    if (this.paymentForm.controls['is_due'].value) {
      if (this.due_remark_mandatory_config_value) {
        if (this.paymentForm.controls['due_reason'].value == "" || this.paymentForm.controls['due_reason'].value == undefined) {
          this.alertService.error("Please select Due Reason");
          this.createDisable = false;
          return;
        }
      }
    }
    if (this.isBillingReasonMissing()) {
      this.alertService.error("Please select Reason Type");
      this.createDisable = false;
      return;
    }
    if ((this.amounts.otp_required && !this.amounts.otp_verified && (this.visible_is_due || this.otp_visibility)) || ((this.visible_is_due || this.otp_visibility) && this.amounts.otp_required_due && !this.amounts.otp_verified_due)) {
      this.alertService.error("Please verify OTP and proceed");
      this.createDisable = false;
    } else {
      if (this.amounts.is_due) {
        if (this.paymentForm.controls['due_amount'].value <= 0) {
          this.resetDueCheckbox();
        }
      }
      if (this.paymentForm.controls['is_used_deposit'].value && this.paymentForm.controls['used_deposit_amount'].value <= 0) {
        this.paymentForm.controls['is_used_deposit'].setValue(false);
        this.paymentForm.controls['deposits'].setValue([]);
      }
      let sum = 0;
      if (this.paymentForm.controls['payment_detail'].value != null) {
        this.paymentForm.controls['payment_detail'].value.forEach(element => {
          if (this.configValueDecimal == "Yes") {
            let receivedAmount = Number(element.received_amount);
            sum += receivedAmount;
          } else {
            sum += element.received_amount;
          }
        });
      }
      this.paymentForm.controls['received_amount'].setValue(sum);
      if (event == 'cancel') {
        this.createBillButton.emit({ "button": event });
      } else if (this.paymentForm.valid) {
        if (this.paymentForm.controls['noOfInstallment'].value == 0) {
          this.navVar[this.findIndexByFieldName('due')].default_open = true; //5
          this.alertService.error("No. of installment can not be 0");
          this.createDisable = false;
          return;
        } let Arr = []; let emtArr = [];
        let obj = { "payment": this.paymentForm.getRawValue(), "button": event, "recovery_uhId": this.rec_uhId, "recovery_empId": this.rec_employeeId, "rec_name": this.rec_name, "isrecovery": (this.paymentForm.controls['noOfInstallment'].value && this.paymentForm.controls['recovery'].value) ? true : false, discountData: this.discountData, dueData: this.dueName, approval_document: this.approvalDocument, hasTotalAmount: this.paymentForm.controls.total_amount.value,is_advance: this.paymentForm.controls.advance_payment.value, advance: this.paymentForm.controls.is_default_amount.value }
if(this.critcality_Data)
{
  obj['patient_criticality_code'] = this.critcality_Data.code;
  obj['patient_criticality_display'] = this.critcality_Data.display;
}
        if (this.discountData && this.discountData.workflow_stage == "single_stage") {
          Arr.push(this.discountData)
          obj['discountData'] = Arr
        }
        if (this.dueName && this.dueName.workflow_stage == "single_stage") {
          emtArr.push(this.dueName)
          obj['dueData'] = emtArr;
        }
        if (this.discountData && this.discountData.workflow_stage == "multi_stage")
          obj['discountData'] = this.responses.discountResponseData
        if (this.dueName && this.dueName.workflow_stage == "multi_stage")
          obj['dueData'] = this.responses.dueResponseData
        if (this.paymentForm.controls['due_amount'] && this.paymentForm.controls['due_amount'].value)
          obj["flow_amount_due"] = this.paymentForm.controls['due_amount'].value
        if (this.paymentForm.controls['discount'] && this.paymentForm.controls['discount'].value)
          obj['flow_amount_discount'] = this.paymentForm.controls['discount'].value
        if ((event == "createBillApprove" || event == 'printBillApprove') && this.dataSet.result_approve_billing) {
          obj['obj_details'] = this.dataSet.result_approve_billing
        }
        // charity billing hides the remarks section, so it can't be mandatory there
        if (!this.isCharitySource() && !this.paymentForm.controls['remarks'].value && (!this.showPaymentdeails || this.paymentForm.controls['recovery'].value)) {
          this.navVar[this.findIndexByFieldName('remarks')].default_open = true; //6
          this.alertService.error("Remarks can not be blank");
          this.createDisable = false;
          return
        }

        if(this.paymentForm.controls['is_discount'].value==true && this.paymentForm.controls['discount_authorized_by'].value == "" && this.paymentForm.controls['type'].value == 'direct'){
          this.alertService.error("Discount by can not be blank");
            this.createDisable = false;
            return
        }

        if (this.paymentForm.controls['recovery'].value == '' && this.paymentForm.controls['noOfInstallment'].value) {
          this.navVar[this.findIndexByFieldName('due')].default_open = true; //5
          this.alertService.error("Employee Recovery can not be blank");
          this.createDisable = false;
          return
        }
        if(printType){
          obj['printType']= printType;
        }

        this.createBillButton.emit(obj);
      } else if (!this.amounts.is_due && this.paymentForm.invalid && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event, "recovery_uhId": this.rec_uhId, "recovery_empId": this.rec_employeeId, "rec_name": this.rec_name, "isrecovery": (this.paymentForm.controls['noOfInstallment'].value && this.paymentForm.controls['recovery'].value) ? true : false });
      } else {
        if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID' && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID' && this.paymentForm.controls['remarks'].status == 'INVALID') {
          if(this.patientInfo.patient_type != 'IP' && this.dataSet.transaction_type != 'optical billing'){
            this.navVar[this.findIndexByFieldName('deposit')].default_open = true; //2
          }
          this.navVar[this.findIndexByFieldName('due')].default_open = true; //5
          this.navVar[this.findIndexByFieldName('remarks')].default_open = true;  //6
          this.alertService.error("Discount by and Remarks can not be blank");
          this.createDisable = false;
        }
        else if (this.paymentForm.controls['discount_authorized_by'].status == 'INVALID' && this.paymentForm.controls['remarks'].status == 'INVALID') {
          if(this.patientInfo.patient_type != 'IP' && this.dataSet.transaction_type != 'optical billing'){
            this.navVar[this.findIndexByFieldName('deposit')].default_open = true; //2
          }
          this.navVar[this.findIndexByFieldName('remarks')].default_open = true; // 6
          this.alertService.error("Discount by and Remarks can not be blank");
          this.createDisable = false;
        }
        else {
          if (this.paymentForm.controls['recovery'].value == '' && this.paymentForm.controls['noOfInstallment'].value) {
            this.navVar[this.findIndexByFieldName('due')].default_open = true; // 5
            this.alertService.error("Employee Recovery can not be blank");
            this.createDisable = false;
          }
          if (this.paymentForm.controls['noOfInstallment'].status == 'INVALID') {
            this.navVar[this.findIndexByFieldName('due')].default_open = true; //5
            this.alertService.error("No. of installment can not be blank");
            this.createDisable = false;
          }

          if (this.paymentForm.controls['is_due'].value==true && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
            this.navVar[this.findIndexByFieldName('due')].default_open = true; //5
            this.alertService.error("Due by can not be blank");
            this.createDisable = false;
          }
          if (this.paymentForm.controls['is_discount'].value==true && this.paymentForm.controls['discount_authorized_by'].status == 'INVALID') {
            // this.navVar[2].default_open = true;
            this.alertService.error("Discount by can not be blank");
            this.createDisable = false;
            if(this.patientInfo.patient_type != 'IP' && this.dataSet.transaction_type != 'optical billing'){
              this.navVar[this.findIndexByFieldName('deposit')].default_open = true; //2
            }
          }
          if (this.paymentForm.controls['remarks'].status == 'INVALID') {
            this.navVar[this.findIndexByFieldName('remarks')].default_open = true;
            this.alertService.error("Remarks can not be blank");
            this.createDisable = false;
          }

        }
        // else if(this.paymentForm.controls['remarks'].status == 'INVALID')
        // this.alertService.error("Remarks can not be blank");
      }
    }
  }
  bookOrder(event) {
    if (this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['used_deposit_amount'] && this.paymentForm.controls['used_deposit_amount'].value > 0 && this.paymentForm.controls['used_deposit_amount'].status == "INVALID")
    {
    this.alertService.error("Please enter valid Used Deposit Amount.");
    return;
    }
    if (this.dataSet && this.dataSet.transaction_type != 'OP Billing') {
      this.bookDisable = true;
      setTimeout(() => {
        this.bookDisable = false;
      }, 3000)
    }
    else
      this.bookDisable = true;
    this.paymentForm.controls['is_visible'].setValue(true);
    if (this.paymentForm.controls['is_discount'].value) {
      if (this.paymentForm.controls['type'].value != 'scheme' && this.discount_remark_mandatory_config_value) {
        if (this.paymentForm.controls['discount_reason'].value == "" || this.paymentForm.controls['discount_reason'].value == undefined) {
          this.alertService.error("Please select Discount Reason");
          this.createDisable = false;
          this.bookDisable = false;
          return;
        }
      }
    }

    if (this.paymentForm.controls['is_due'].value) {
      if (this.due_remark_mandatory_config_value) {
        if (this.paymentForm.controls['due_reason'].value == "" || this.paymentForm.controls['due_reason'].value == undefined) {
          this.alertService.error("Please select Due Reason");
          this.createDisable = false;
          this.bookDisable = false;
          return;
        }
      }
    }
    if (this.isBillingReasonMissing()) {
      this.alertService.error("Please select Reason Type");
      this.createDisable = false;
      this.bookDisable = false;
      return;
    }
    if ((this.amounts.otp_required && !this.amounts.otp_verified && (this.visible_is_due || this.otp_visibility)) || ((this.visible_is_due || this.otp_visibility) && this.amounts.otp_required_due && !this.amounts.otp_verified_due)) {
      this.alertService.error("Please verify OTP and proceed");
    } else {
      if (this.amounts.is_due) {
        if (this.paymentForm.controls['due_amount'].value <= 0) {
          this.resetDueCheckbox();
        }
      }
      if (this.paymentForm.controls['is_used_deposit'].value && this.paymentForm.controls['used_deposit_amount'].value <= 0) {
        this.paymentForm.controls['is_used_deposit'].setValue(false);
      }
      let sum = 0;
      this.paymentForm.controls['payment_detail'].value.forEach(element => {
        sum += element.received_amount;
      });
      this.paymentForm.controls['received_amount'].setValue(sum);
      if (event == 'cancel') {
        this.createBillButton.emit({ "button": event });
      } else if (this.paymentForm.valid) {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else if (!this.amounts.is_due && this.paymentForm.invalid && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else {
        // this.alertService.error("Please fill required fields");
      }
      if (event == "bookOrder") {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event, "isCall": true });
      }
    }
  }
  draftOrder(event) {
    if (this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['used_deposit_amount'] && this.paymentForm.controls['used_deposit_amount'].value > 0 && this.paymentForm.controls['used_deposit_amount'].status == "INVALID")
    {
    this.alertService.error("Please enter valid Used Deposit Amount.");
    return;
    }
    if (this.dataSet && this.dataSet.transaction_type != 'OP Billing') {
      this.draftDisable = true;
      setTimeout(() => {
        this.draftDisable = false;
      }, 3000)
    }
    else
      this.draftDisable = true;
    this.paymentForm.controls['is_visible'].setValue(true);
    if (this.paymentForm.controls['is_discount'].value) {
      if (this.paymentForm.controls['type'].value !='scheme' && this.discount_remark_mandatory_config_value) {
        if (this.paymentForm.controls['discount_reason'].value == "" || this.paymentForm.controls['discount_reason'].value == undefined) {
          this.alertService.error("Please select Discount Reason");
          this.createDisable = false;
          this.draftDisable = false;
          return;
        }
      }
    }

    if (this.paymentForm.controls['is_due'].value) {
      if (this.due_remark_mandatory_config_value) {
        if (this.paymentForm.controls['due_reason'].value == "" || this.paymentForm.controls['due_reason'].value == undefined) {
          this.alertService.error("Please select Due Reason");
          this.createDisable = false;
          this.draftDisable = false;
          return;
        }
      }
    }

    if ((this.amounts.otp_required && !this.amounts.otp_verified && (this.visible_is_due || this.otp_visibility)) || ((this.visible_is_due || this.otp_visibility) && this.amounts.otp_required_due && !this.amounts.otp_verified_due)) {
      this.alertService.error("Please verify OTP and proceed");
    } else {
      if (this.amounts.is_due) {
        if (this.paymentForm.controls['due_amount'].value <= 0) {
          this.resetDueCheckbox();
        }
      }
      if (this.paymentForm.controls['is_used_deposit'].value && this.paymentForm.controls['used_deposit_amount'].value <= 0) {
        this.paymentForm.controls['is_used_deposit'].setValue(false);
      }
      let sum = 0;
      this.paymentForm.controls['payment_detail'].value.forEach(element => {
        sum += element.received_amount;
      });
      this.paymentForm.controls['received_amount'].setValue(sum);
      if (event == 'cancel') {
        this.createBillButton.emit({ "button": event });
      } else if (this.paymentForm.valid) {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else if (!this.amounts.is_due && this.paymentForm.invalid && this.paymentForm.controls['due_authorised_by_id'].status == 'INVALID') {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event });
      } else {
        // this.alertService.error("Please fill required fields");
      }
      if (event == "draftOrder") {
        this.createBillButton.emit({ "payment": this.paymentForm.getRawValue(), "button": event, "isCall": true });
      }
    }
  }
//   onGuarantorClicked(e){
//     if(this?.paymentForm?.controls?.due_amount?.value > 0 && this?.paymentForm?.controls['guarantor_details'].length > 0 ){
//     this.totalGuaranteedAmount = this?.paymentForm?.controls['guarantor_details'].forEach(element => {
      
//     });
//     }

// }

onGuarantorClicked(e: any) {
  // Recompute unconditionally: guarding on due_amount > 0 left a stale total
  // behind whenever due dropped to 0. beforeSubmitValidation no longer reads
  // this field (it sums guarantor_details directly, excluding the edited row);
  // it is kept only for display/consumers of the running total.
  const rows = this.paymentForm?.controls['guarantor_details']?.value || [];
  this.totalGuaranteedAmount = 0;

  rows.forEach((element: any) => {
    this.totalGuaranteedAmount += Number(element.total_guerrentied_amount) || 0;
  });
}
  valueChangeStart(e: any, obj) {
//     if(this.discount_remark_mandatory_config_value && e.value.type === 'scheme'){
//    if (e.question && e.question.key === "type" && e.val?.type === "scheme" && obj.form.controls['discount_reason']) {
//   obj.form.controls['discount_reason'].question_component.question.required = false;
// }}
    setTimeout(() => {
      if(e && e.question && e.question.key == "payment_mode_id" && e.val && e.val.code && e.val.code == "pos" && obj && obj.form && obj.form.controls && obj.form.controls['pos_option_code'] && this.sap_opt_config && this.sap_opt_config != "no"){
      obj.form.controls['pos_option_code'].question_component.question.required = true;
    }
    });
      

    if(obj.id == "main" && obj.type == "popup" && this.updatedReciptNoRequired == false && obj.form.controls.recipt_no && obj.form.controls.recipt_no._pendingDirty == false){
      this.currentReciptNo = obj.form.controls.recipt_no.value
      this.currentreciptamount = obj.form.controls.used_deposit_amount.value
    }
    if (e && (e.question.key == "used_deposit_amount") && e.val != undefined && e.val && obj.form.controls && obj.form.controls.available_amount != undefined && obj.form.controls.available_amount.value != undefined) {    
      if (obj.form.controls.available_amount.value < obj.form.controls.used_deposit_amount.value) {
        obj.form.controls.used_deposit_amount.errors = { required: true };
        obj.form.controls.used_deposit_amount.status = "INVALID";
       } 
       else if (obj.form.controls.available_amount.value > obj.form.controls.used_deposit_amount.value) {
        obj.form.controls.used_deposit_amount.errors = null;
        obj.form.controls.used_deposit_amount.status = "VALID";
      }
   }
   if(e && e.question && e.question.key == "available_amount"  && ((obj?.form?.controls?.used_deposit_amount?.value == 0 && this.paymentForm?.controls?.net_receivable_amount?.value !=0 ) || (obj.id == "main" && this.apiCheck == false))){

    if(obj?.form?.controls?.recipt_no?.value != "" && obj.id != "main" && obj?.form?.controls?.advance_type?.value === "All"){
      if(obj.form.controls.available_amount.value > this.paymentForm.controls.net_receivable_amount.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(this.paymentForm.controls.net_receivable_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
      if(obj.form.controls.available_amount.value < this.paymentForm.controls.net_receivable_amount.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.available_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
      if(obj.form.controls.available_amount.value == this.paymentForm.controls.net_receivable_amount.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.available_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
    }
    else if(obj?.form?.controls?.recipt_no?.value != "" && obj.id != "main" && obj?.form?.controls?.advance_type?.value != "All" && e.question.key != "used_deposit_amount")
    obj.form.controls['used_deposit_amount'].setValue(0);
    if(obj?.form?.controls?.recipt_no?.value != "" && obj.id == "main" && obj?.form?.controls?.advance_type?.value === "All"){
      if(obj.form.controls.available_amount?.value > obj.form.controls.used_deposit_amount?.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.used_deposit_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
      if(obj.form.controls.available_amount?.value < obj.form.controls.used_deposit_amount?.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.available_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
      if(obj.form.controls.available_amount?.value == obj.form.controls.used_deposit_amount?.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.available_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
    }
    if(!this.apiCheck)
    {
      setTimeout(() => {
      let fromvalue
      if(this.dataSet.transaction_type == "Pharmacy Billing"){
        fromvalue = "OP_PHARMACY_BILLING"
      }
      else{
        fromvalue = "OP_BILLING"
      }
      let uhId_args = this.dataSet.uhId ? this.dataSet.uhId : this.dataSet.op_amount_value.uhId
        let args = "uhId:" + uhId_args + ",from:" + fromvalue;
      if(obj?.form?.controls?.recipt_no?.question_component?.question)
      {
      obj.form.controls.recipt_no.question_component.question.datasource = {
        "application": "payment",
        "resource": "deposit",
        "query_id": "GET_DEPOSIT_BY_UHID",
        "args": args
      }
    }
      this.apiCheck = true;
      if(obj?.form?.controls?.recipt_no)
      {
      obj.form.controls.recipt_no.updateValueAndValidity({ onlySelf: true, emitEvent: true })
      }
    },);
  }
   }
   else if(e && e.question && e.question.key == "available_amount" && this.paymentForm.controls.net_receivable_amount.value ==0){
    setTimeout(() => {
      if(obj.form.controls.recipt_no.question_component && (obj.form.controls.recipt_no.question_component.question.datasource == "" || obj.form.controls.recipt_no.question_component.question.datasource == undefined)) {
        let fromvalue
        if(this.dataSet.transaction_type == "Pharmacy Billing"){
          fromvalue = "OP_PHARMACY_BILLING"
        }
        else{
          fromvalue = "OP_BILLING"
        }
        let uhId_args = this.dataSet.uhId ? this.dataSet.uhId : this.dataSet.op_amount_value.uhId
        let args = "uhId:" + uhId_args + ",from:" + fromvalue;
        obj.form.controls.recipt_no.question_component.question.datasource = {
          "application": "payment",
          "resource": "deposit",
          "query_id": "GET_DEPOSIT_BY_UHID",
          "args": args
        }
        obj.form.controls.recipt_no.updateValueAndValidity({ onlySelf: true, emitEvent: true })
      }
    },);
   }
   else if(e && e.question && e.question.key == "available_amount" && this.paymentForm.controls.net_receivable_amount.value !=0){
    setTimeout(() => {
      if(obj?.form?.controls?.recipt_no?.question_component && (obj?.form?.controls?.recipt_no?.question_component?.question?.datasource == "" || obj?.form?.controls?.recipt_no?.question_component?.question?.datasource == undefined)) {
        let fromvalue
        if(this.dataSet.transaction_type == "Pharmacy Billing"){
          fromvalue = "OP_PHARMACY_BILLING"
        }
        else{
          fromvalue = "OP_BILLING"
        }
        let uhId_args = this.dataSet.uhId ? this.dataSet.uhId : this.dataSet.op_amount_value.uhId
        let args = "uhId:" + uhId_args + ",from:" + fromvalue;
        obj.form.controls.recipt_no.question_component.question.datasource = {
          "application": "payment",
          "resource": "deposit",
          "query_id": "GET_DEPOSIT_BY_UHID",
          "args": args
        }
        obj.form.controls.recipt_no.updateValueAndValidity({ onlySelf: true, emitEvent: true })
      }
    },);
   }
   if(obj.form.controls.recipt_no && obj.form.controls.recipt_no.value != "" && obj.form.controls.used_deposit_amount.value != 0 && e && e.question.key == "available_amount"){
    if(obj.id == "main" && obj?.form?.controls?.advance_type?.value === "All"){
      if(obj.form.controls.available_amount.value > obj.form.controls.used_deposit_amount.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.used_deposit_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
      if(obj.form.controls.available_amount.value < obj.form.controls.used_deposit_amount.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.available_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
    }
    if(obj.id != "main" && obj?.form?.controls?.advance_type?.value === "All"){
      if(obj.form.controls.available_amount.value > this.paymentForm.controls.net_receivable_amount.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(this.paymentForm.controls.net_receivable_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
      if(obj.form.controls.available_amount.value < this.paymentForm.controls.net_receivable_amount.value){
        obj.form.controls['used_deposit_amount'].setValue(Number(obj.form.controls.available_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
    }
  }
    if (obj.form.controls['payment_mode_id'] != undefined && obj.form.controls['payment_mode_id'].value == "icici_qr_code") {
      // let _resource = { "amount": this.dataSet.amount, "gateway_id": "dc9e7ef0-1332-11ec-8788-762b9b69d3e3-31", "refId": this.dataSet.uhId, "transactionID": "abc123" }
      // this.baseService.action(_resource, 'GENERATE_QR_CODE', 'payment-gateway', 'payment_qr_code').subscribe(
      //   (data: any) => {
      //     if (data.errCode == 0 && data.resource.length > 0) {
      //       let qrCodeData = data.resource[0].qr_code;
      //       this.openQrCodeModal(qrCodeData);
      //     } else {
      //       this.alertService.error(data.message);
      //     }
      //   });
    // }
      
    }
  if(obj?.form?.controls?.advance_type?.value != "All" && obj.id != "main" && e.question.key != "used_deposit_amount" && obj?.form?.controls?.['used_deposit_amount'])
  obj.form.controls['used_deposit_amount'].setValue(0);
   if (obj.form.controls.available_amount && obj.form.controls.used_deposit_amount && obj.form.controls.available_amount.value > obj.form.controls.used_deposit_amount.value && obj.form.controls.used_deposit_amount.value != 0) {
    obj.form.controls.used_deposit_amount.errors = null;
    obj.form.controls.used_deposit_amount.status = "VALID";
  }
  if (obj.form.controls.used_deposit_amount && obj.form.controls.used_deposit_amount.value == 0) {
    obj.form.controls.used_deposit_amount.errors = { required: true };
    obj.form.controls.used_deposit_amount.status = "INVALID";
   } 
    this.objval = obj;
    if(this.objval!=undefined && this.objval.id == this.paymentResource && this.objval.form!=undefined && this.objval.form['_manualChange']==false){
      if(e.question!=undefined && e.question.key=="payment_mode_id" && this.route!=undefined && this.route.snapshot!=undefined && this.route.snapshot.routeConfig!=undefined && this.route.snapshot.routeConfig.path!=undefined && this.route.snapshot.routeConfig.path=="opbillingeditbill"){
        if(obj.form.controls['view_payment_details']!=undefined && obj.form.controls['view_payment_details'].question_component!=undefined && obj.form.controls['view_payment_details'].question_component.question!=undefined)
        obj.form.controls['view_payment_details'].question_component.question.visible = true;
      }
    }
    if (obj && obj.id == this.paymentResource){
      if (obj.form.controls['payment_mode_id'].value == "cash" && obj.form.controls['bank_id'].question_component != undefined) {
        obj.form.controls['bank_id'].question_component.question.visible = false;
      }
      if (obj.form.controls['bank_id'].question_component) {
        if (obj.form.controls['payment_mode_id'] != undefined) {
          if (obj.form.controls['payment_mode_id'].value == "cheque" || obj.form.controls['payment_mode_id'].value == "dd" || obj.form.controls['payment_mode_id'].value == "rtgs" || obj.form.controls['payment_mode_id'].value == "neft") {
            if (obj.form.controls['bank_id'] != undefined)
              obj.form.controls['bank_id'].question_component.question.required = true;
          }
          else
            obj.form.controls['bank_id'].question_component.question.required = false;
        }
        obj.form.controls['bank_id'].updateValueAndValidity({ onlySelf: true, emitEvent: true });
      }
      if (obj.form.controls['payment_mode_id'] != undefined && obj.form.controls['payment_mode_id'].value == "pos" && obj.form.controls['integrated_pos_machine'] && obj.form.controls['integrated_pos_machine'].value == 'integrated_pos') {
        if (obj.form.controls['transaction_no'] && obj.form.controls['transaction_no'].question_component) {
          obj.form.controls['transaction_no'].question_component.question.disabled = true
        }
      } else {
        if (obj.form.controls['transaction_no'] && obj.form.controls['transaction_no'].question_component) {
          obj.form.controls['transaction_no'].question_component.question.disabled = false
        }
      }
      if (obj && obj.form && obj.form.controls && obj.form.controls['transaction_no'] && Number(obj.form.controls['transaction_no'].value) <=9 && obj.form.controls['transaction_no'].touched == true) {
        obj.form.controls['transaction_no'].setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(40)])
        obj.form.controls['transaction_no'].updateValueAndValidity(); 
      }
    } else if (obj && obj.id == "sponsor_fund"){
        //TODO
    }
    if(obj && obj.form && obj.form.controls && obj.form.controls.recipt_no && e.question.key == "recipt_no" && obj.id == "deposit_payment_detail"){
      if (e && (e.question.key == "used_deposit_amount") && e.val != undefined && e.val && obj.form.controls && obj.form.controls.available_amount != undefined && obj.form.controls.available_amount.value != undefined) {    
        if (obj.form.controls.available_amount.value < obj.form.controls.used_deposit_amount.value) {
          obj.form.controls.used_deposit_amount.errors = { required: true };
          obj.form.controls.used_deposit_amount.status = "INVALID";
         } 
         else if (obj.form.controls.available_amount.value > obj.form.controls.used_deposit_amount.value) {
          obj.form.controls.used_deposit_amount.errors = null;
          obj.form.controls.used_deposit_amount.status = "VALID";
        }
     }
     if (obj.form.controls.available_amount && obj.form.controls.used_deposit_amount && obj.form.controls.available_amount.value > obj.form.controls.used_deposit_amount.value && obj.form.controls.used_deposit_amount.value != 0) {
      obj.form.controls.used_deposit_amount.errors = null;
      obj.form.controls.used_deposit_amount.status = "VALID";
    }
      obj.form.controls['used_deposit_amount'].updateValueAndValidity();
    }
   

  }

  openQrCodeModal(qrCodeData) {
    let object = {
      data: qrCodeData,
    }
    this.smartModalService.open(QrCodeGeneratorComponent, object, "QR Code", ModalSize.Lg).subscribe(res => { }, err => { })
  }
  
  beforeSubmitValidation(obj, cb) {

    if(this.paymentForm && this.paymentForm.controls && obj && obj.currentForm && obj.currentForm.value && obj.currentForm.value.transaction_no && obj.currentForm.value.transaction_no.length == 1){
      this.alertService.error("Length of Transaction No should be greater than 1");
      return;
    }

    // if(this?.totalGuaranteedAmount > 0){
    //   let addedAMount = obj?.currentForm?.controls?.total_guerrentied_amount?.value + this.totalGuaranteedAmount;
    //   if(addedAMount > this?.paymentForm?.controls?.due_amount?.value){
    //    this.alertService.error("Guarantor Amount cannot be greater than due amount");
    //   return;
    //   }
    // }
    // if(obj?.currentForm?.controls?.total_guerrentied_amount?.value > this?.paymentForm?.controls?.due_amount?.value){
    //    this.alertService.error("Guarantor Amount cannot be greater than due amount");
    //   return;
    // }
    //guarantor row popup — searchselect writes the employee's emp_no into employeeId, so an employee
    //without an emp code lands as a blank employeeId with a populated employee_name (same check as updateGuarantorAmount)
    const guarantorControls = obj?.currentForm?.controls;
    if (guarantorControls?.employeeId && guarantorControls?.total_guerrentied_amount && guarantorControls?.employee_name?.value && !String(guarantorControls.employeeId.value ?? "").trim()) {
      this.alertService.error("Employee code is not available for the selected employee");
      return;
    }
    if (obj?.currentForm?.controls?.total_guerrentied_amount?.value != undefined) {
      const currentAmount = Number(obj?.currentForm?.controls?.total_guerrentied_amount?.value) || 0;
      const dueAmount = Number(this?.paymentForm?.controls?.due_amount?.value) || 0;
      const rows = this.paymentForm?.controls['guarantor_details']?.value || [];
      // On Update the edited row is already in guarantor_details, so summing every
      // row and then adding currentAmount counted it twice and rejected valid
      // reductions. Sum the OTHER rows only; currentAmount represents this one.
      const editingId = obj?.currentForm?.value?.employeeId;
      const othersTotal = rows.reduce((sum: number, row: any) => {
        if (editingId != undefined && row?.employeeId === editingId) {
          return sum;
        }
        return sum + (Number(row?.total_guerrentied_amount) || 0);
      }, 0);

      if (currentAmount + othersTotal > dueAmount) {
        this.alertService.error("Guarantor Amount cannot be greater than due amount");
        return;
      }
    }
   

    if(this.paymentForm && this.paymentForm.controls && obj && obj.currentForm && obj.currentForm.value && obj.currentForm.value.sanctioned_amount && obj.currentForm.value.sanctioned_amount > this.paymentForm.controls.net_receivable_amount.value){
      this.alertService.error("Sanctioned amount can not be greater than Final Amount");
      return;
    }
    if(obj && obj.currentForm && obj.currentForm.value && obj.currentForm.value.sponsor_code && this.dataSet && (this.dataSet.transaction_type == "Pharmacy Billing" || this.dataSet.transaction_type == 'OP Billing' || this.dataSet.transaction_type == 'OP Edit Billing') && (obj.currentBtnVal && obj.currentBtnVal.label != "Update"))
      {
    for (let i of this.paymentForm.controls.sponsor_fund.value) {
      if ((i['sponsor_code'] === obj.currentForm.value.sponsor_code) && (i['db_id'] === obj.currentForm.value.db_id)) {
        this.alertService.error('Duplicate Sponsor Names not allowed');
        return;
      }
    }
    };
    this.objval = obj.currentForm;
    if (obj && obj.currentForm.value.hasOwnProperty('payment_mode_id')){
      if (this.objval.controls['payment_mode_id'].value == "cheque" || this.objval.controls['payment_mode_id'].value == "dd" || this.objval.controls['payment_mode_id'].value == "rtgs" || this.objval.controls['payment_mode_id'].value == "neft") {
        if (this.objval.controls['bank_id'].value == "") {
          this.formService.alerts.error("Paid Through can't be blank.")
          return false;
        }
      }
      if (this.objval.controls['payment_mode_id'].value != "cash" && this.objval.controls['transaction_no'].value == "" && this.dataSet.transaction_type == 'Pharmacy Billing' && !this.objval.controls['transaction_no'].question_component.question.disabled) {
        this.formService.alerts.error("Transaction no can't be blank.")
        return false;
      }
      if (this.objval.controls['payment_mode_id'].value == "pos" && this.objval.controls['pos_option_code'].value == "" && this.sap_opt_config == "yes") {
        this.alertService.error("Payment Option Type can't be blank.")
        return;
      }
      if (this.objval.controls['payment_mode_id'].value == "pos" && this.objval.controls['transaction_no'].value == "" && !this.objval.controls['transaction_no'].question_component.question.disabled) {
        this.formService.alerts.error("Transaction no can't be blank.")
        return false;
      }
      if (this.objval.controls['payment_mode_id'].value == "pos" && this.objval.controls['integrated_pos_machine'].value == "") {
        this.formService.alerts.error("Choose POS Option can't be blank")
        return false;
      }
      else
        return true;
    } 
    else if(obj && obj.currentForm.value.hasOwnProperty('recipt_no')){
      if(obj.currentBtnVal.label != "Update"){
        for (let i of this.paymentForm.controls.deposits.value) {
          if (i['recipt_no'] == obj.currentForm.value.recipt_no) {
            this.alertService.error('Duplicate Receipt No. not allowed');
            return;
          }
        }
        if(this.paymentForm.controls['net_receivable_amount'].value == 0 &&  obj.currentForm.value['used_deposit_amount'] > 0){
          obj.currentForm.controls['used_deposit_amount'].setValue(0);
          obj.currentForm.controls['recipt_no'].setValue("");
          obj.currentForm.controls['available_amount'].setValue(0);
          this.alertService.error('Can Not Use Deposit More Than Net Payable Amount. Used Deposit Resetting.');
          return;
        }
      }
      if(obj.currentBtnVal.label == "Update"){
        for (let i of this.paymentForm.controls.deposits.value) {
          if(i['recipt_no'] == obj.currentForm.value.recipt_no && this.currentReciptNo != obj.currentForm.value.recipt_no){
            this.alertService.error('Duplicate Receipt No. not allowed');
            return;
          }
        }
      }
      return true;
    }
    else if (obj && obj.currentForm.value.hasOwnProperty('sponsor_name')){
      let formValue = obj.currentForm.value;

      if (!formValue.amount && obj.currentForm.value.sponsor_billing != true) {
        this.formService.alerts.error(`Please enter the amount.`);
        return false;
      }
        if (!formValue.sponsor_name && obj.currentForm.value.sponsor_billing == true) {
        this.formService.alerts.error(`Please Select Sponsor Name`);
        return false;
      }
      if (!formValue.sanctioned_amount && obj.currentForm.value.sponsor_billing == true) {
        this.formService.alerts.error(`Please enter the sanctioned amount.`);
        return false;
      }
      if (formValue.sanctioned_amount > formValue.available_amount && obj.currentForm.value.sponsor_billing == true) {
        this.formService.alerts.error(`Sanction Amount can not greater than  Sanction Available amount`);
        return false;
      }
      if (formValue.sanctioned_amount > formValue.sanctioned_list && obj.currentForm.value.sponsor_billing == true) {
        this.formService.alerts.error(`Sanction Amount can not greater than Sanctioned list amount`);
        return false;
      }
      if (formValue.sanctioned_amount > this.paymentForm.controls.net_amount.value &&obj.currentForm.value.sponsor_billing == true) {
        this.formService.alerts.error(`Sanction Amount can not greater than Total amount`);
        return false;
      }
      if (formValue.sanctioned_amount > formValue.sanctioned_list && obj.currentForm.value.sponsor_billing == true) {
        this.formService.alerts.error(`Sanction Amount can not greater than Sanctioned list amount`);
        return false;
      }

      if (formValue.amount <= 0 && obj.currentForm.value.sponsor_billing != true) {
        this.formService.alerts.error(`Amount should be greater than 0.`);
        return false;
      }

      if (formValue.amount > formValue.total_available_balance && obj.currentForm.value.sponsor_billing != true) {
        this.formService.alerts.error(`Please ensure the amount does not exceed the available balance.`);
        return false;
      }

      if (obj.currentBtnVal.label !== "Update" && obj.currentForm.value.sponsor_billing != true) {
        let existingSponsors = this.paymentForm.controls.sponsor_fund.value;
        if (existingSponsors.length > 0) {
          let isSponsorExist = existingSponsors.some(d => d.sponsor_name === formValue.sponsor_name);
          if (isSponsorExist) {
            this.formService.alerts.error(`${formValue.sponsor_name} already added.`);
            return false;
          }
        }
      }
      if (obj.currentForm.value.sponsor_billing != false && obj.currentBtnVal.label !== "Update") {
        obj.currentForm.controls.randomupdateId.setValue(Math.floor((Math.random() * 100)))
        this.addsponsorAmount([obj.currentForm.value])
        return true;
      }
      if (obj.currentForm.value.sponsor_billing != false && obj.currentBtnVal.label == "Update") {
        this.updatesponsorAmount([obj.currentForm.value],'update')
      }
      return true;
    }
    if(obj.currentBtnVal.label == "Update" && this.amounts.is_due && obj.currentForm.valuepayment_mode){
      this.resetDueCheckbox();
     }
     return true;
  }
  customPatternapplid() {
    if (this.configValueDecimal == "No") {
      return "^[0-9+]*$"
    }
    else {
      return "^\\d{1,9}(\\.\\d{1,2})?$"
    }
  }
  valueChangeEnd(e: any, obj) {
    this.mainOBj = obj;
    PaymentModeFlagsDecorator.applyFlags(e, obj);
    PaymentModeFlagsDecorator.hideGridColumns(this.compositeArrayComponent);
  //   if (e.val == "integrated_pos") {
  //     let deviceID = this.appService.readCookie('device_id');
  //     let resource = {
  //         deviceId: deviceID,
  //         amount: obj.form.controls.received_amount.value,
  //         uhId: this.patientInfo.uhId,
  //         pos_option_code: obj.form.controls.pos_option_code.value,
  //         pos_option_name: obj.form.controls.pos_option_name.value
          
  //     }
  //     this.formService.baseService.action(resource, 'POS_PAYMENT_REQUEST', 'payment-gateway', 'ui_gateway_response').subscribe(response => {
  //         console.log("Resopnse from payment gateway", response)
  //         if (response && response.resource && response.resource[0] && response.resource[0].extra_data) {
  //             this.pos_transaction_id = response.resource[0].extra_data.gateway_transactionId
  //             this.transaction_no = response.resource[0].extra_data.gateway_transactionId
  //             this.kx_transaction_no = response.resource[0].extra_data.kx_transactionId
  //         }
  //         obj.form.controls.transaction_no.setValue(this.transaction_no)
  //     });
  // }
  if(e.question!=undefined && e.question.key=="view_payment_details" && obj.form.controls['view_payment_details']!=undefined && obj.form.controls['view_payment_details'].question_component!=undefined && obj.form.controls['view_payment_details'].question_component.question!=undefined && obj.form.controls['view_payment_details'].question_component.question._manualChange==true){
    if (e.question != undefined && e.question.key && (e.question.key == 'view_payment_details')) {
      let args = "transaction_id:" + this.value_data.bill_no;

      this.baseService.get('GET_PAYMENT_DETAILS_FOR_EDIT_BILL',args,'payment_transaction_details', 'payment').subscribe((result) => {
        if (result.errCode == 0 && result.resource && result.resource.length > 0) {
            let object = {
                resource: "payment_details_view_edit_bill",
                action: "LIST",
                preDefinedData: { resource: result.resource },
                config: {
                    "print_allowed": false,
                    "viewAll": true,
                    "hideSearchBox": true,
                    "hideResult": true,
                    "allowPagination": false
                }
            }
            this.smartModalService.open(PopupFormComponent, object, "View Payment Details", ModalSize.Lg).subscribe(res => { }, err => { })
        }
        else { }
    })
  }
  }
    if (e.question != undefined && e.question.key == "received_amount" && (obj.id == this.paymentResource || (obj.id == "main" && obj.type == "popup"))) {
     if(this.dataSet && this.dataSet !=undefined &&  this.dataSet.transaction_type !=undefined && this.dataSet.transaction_type == "optical billing"){
      this.showdata("fill_amount");
      }
      setTimeout(() => {
        if (this.configValueDecimal == "Yes") {
          e.question.pattern = "^\\d{1,9}(\\.\\d{1,2})?$";
          if (obj.form.controls['received_amount'] && obj.form.controls['received_amount'].value != "") {
            this.changeDueAmountDecimal = true;
            var receivedAmountDecimal = Number(obj.form.controls['received_amount'].value);
            // if(this.paymentForm.controls['advance_payment'].value !=""){
            //   receivedAmountDecimal = receivedAmountDecimal - this.paymentForm.controls['advance_payment'].value
            // }
             
                obj.form.controls['received_amount'].setValue(receivedAmountDecimal.toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
              
          }
        } else {
          e.question.pattern = "^[0-9+]*$";
        }
      }, 100);
    }
    if (e != undefined && e.question != undefined && e.question.key != undefined && e.question.key == "payment_mode_id") {
      if (obj.form.controls['payment_mode_id'] != undefined && obj.form.controls['payment_mode_id'].value != "cash" && obj.form.controls['bank_id'] != undefined && obj.form.controls['bank_id'].question_component != undefined) {

        obj.form.controls['bank_name'].status = "VALID";
        obj.form.controls['bank_id'].status = "VALID";
        let data = {
          'args': `payment_mode_code:${obj.form.controls['payment_mode_id'].value},facility_master_type:PAYMENTMODEMAPPING`
        }

        var queryId = "getOrganizationSetup"
        this.formService.baseService.getData(data, "", "facility_master", "facility-management", queryId).subscribe(res => {
          if (res.errCode == 0 && res.resource.length > 0) {
            obj.form.controls['bank_id'].question_component.question.options = res.resource;

          } else {
            obj.form.controls['bank_id'].question_component.question.options = [];
            if (obj.form.controls['bank_name'].value != "") {
              obj.form.controls['bank_name'].setValue("");
              obj.form.controls['bank_name'].status = "VALID";
            }

            if (obj.form.controls['bank_id'].value != "") {
              obj.form.controls['bank_id'].setValue("");
              obj.form.controls['bank_id'].status = "VALID";
            }

          }

        })

      }
    }
  }

  onPaymentRemove(event) {
    let deletedItem = event.itemss[event.index]?.integrated_pos_machine
    if (deletedItem == 'integrated_pos') {
      let deviceID = this.appService.readCookie('device_id');
      let gateway_transactionId = event.itemss[event.index].transaction_no
      let kx_transactionId = event.itemss[event.index].kx_transaction_no
      let resource = {
        deviceId: deviceID,
        amount: event.itemss[event.index].received_amount,
        uhId: this.patientInfo.uhId,
        extra_data: {
          gateway_transactionId: gateway_transactionId,
          kx_transactionId: kx_transactionId
        }
      }
      this.baseService.action(resource, 'CANCEL_POS_PAYMENT_REQUEST', 'payment-gateway', 'ui_gateway_response').subscribe(response => {
        console.log("Resopnse from payment gateway", response)
        if (response && response.resource && response.resource[0] && response.resource[0].extra_data.responseCode == '200') {
          this.payment_gateway_cancel_response = response.resource[0].extra_data.responseCode
        }
      });
    }
    this.amounts.removedAmount = this.amounts.paidAmount[event.index];
    if (this.amounts.removedAmount == undefined || this.amounts.removedAmount == '') {
      this.amounts.removedAmount = 0;
    }
    this.amounts.paidAmount.splice(event.index, 1);
    if (event.items.length > 0) {
      this.amounts.sum = 0;
      for (let entry of event.items)
        this.amounts.sum += Number(entry.received_amount);
    } else {
      this.amounts.sum = 0;
    }

    if (this.amounts.is_due && this.calledAction == "") {
      this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['net_receivable_payer_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    }
    let patientAmount = this.paymentForm.controls['final_amount'].value;
    if(this.paymentForm.controls['due_amount'] && isNaN(this.paymentForm.controls['due_amount'].value)){
      this.paymentForm.controls['due_amount'].setValue(0)
    }
    if(this.amounts.is_due == false){
      this.paymentForm.controls['due_amount'].setValue(0)
    }
    this.amounts.netPayableAmount = this.paymentForm.controls.is_sponsor_fund_applied.value == true ? (patientAmount - this.amounts.sum - this.paymentForm.controls['due_amount'].value) : (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value);
    if(this.paymentForm && this.paymentForm.controls && this.paymentForm.controls['authorised_amount'].value >0 ){
      this.amounts.netPayableAmount = this.paymentForm.controls.is_sponsor_fund_applied.value == true ? this.paymentForm.controls['net_amount'].value - this.amounts.sum - this.paymentForm.controls['due_amount'].value - this.paymentForm.controls['authorised_amount'].value : this.paymentForm.controls['net_amount'].value - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value - this.paymentForm.controls['due_amount'].value - this.paymentForm.controls['authorised_amount'].value
    }
    if(this.amounts.is_due && this.calledAction == ""){
    this.amounts.netPayableAmount = this.paymentForm.controls.is_sponsor_fund_applied.value == true ? (patientAmount - this.amounts.sum) : (patientAmount - this.amounts.sum - this.paymentForm.controls['used_deposit_amount'].value);
    }
    this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
    if(this.amounts.is_due && this.calledAction == ""){
      this.resetDueCheckbox();
    }
  }
  onDepositRemove(event) {
    this.amounts.removedAmount = this.amounts.paidAmount[event.index];
    if (this.amounts.removedAmount == undefined || this.amounts.removedAmount == '') {
      this.amounts.removedAmount = 0;
    }
    this.amounts.paidAmount.splice(event.index, 1);
    if (event.items.length > 0) {
      this.amounts.sum = 0;
      for (let entry of event.items)
        this.amounts.sum += Number(entry.received_amount);
    } else {
      this.paymentForm.controls["used_deposit_amount"].setValue(0);
      this.amounts.sum = 0;
    }

    if (this.amounts.is_due) {
      this.paymentForm.controls['due_amount'].setValue(Number(this.paymentForm.controls['final_amount'].value - this.amounts.sum - event.itemss[event.index].used_deposit_amount - this.paymentForm.controls['net_receivable_payer_amount'].value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
    }
    let patientAmount = this.paymentForm.controls['final_amount'].value;
    this.amounts.netPayableAmount = (patientAmount - this.amounts.sum + (this.total_service_amount - event.itemss[event.index].used_deposit_amount)- this.paymentForm.controls['due_amount'].value);
    this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
    this.resetPaymentDetail();
    this.resetDueCheckbox();
  }

  checkCompositeInputAmt(evt) {
    if (evt.target['valueAsNumber'] > Number(this.amounts.netPayableAmount)) {
      document.getElementsByClassName('kx-w-85')[0]['disabled'] = true;
    } else {
      document.getElementsByClassName('kx-w-85')[0]['disabled'] = false;
    }
  }

  ngOnDestroy() { }

  schemeSetup(value) {
    if (value.type && value.type.toLowerCase() == "scheme" && value.schemeId != undefined && value.schemeId) {
      try {
        console.log("Data ", this.dataSet);
        this.schemeApiSignature['args'] = "";
        // if(this.dataSet.orderedFrom == "Optical Order"){
        //   this.schemeApiSignature['args'] = "applicable_on:CUSTOM_SCHEME"
        // }
        this.loader.showSpinner();
        this.baseService.getByDataSource(this.schemeApiSignature).subscribe(res => {
          this.loader.hideSpinner();
          console.log('scheme api data ==>>', res);
          if (res.errCode == 0 && res.count > 0) {
            // this.responses.schemeResponse = res.resource;
            this.paymentForm.controls['scheme'].setValue(value.schemeId);
          }
        })
      } catch (e) {
        console.error('Error => ', e);
      }
      this.visibility.discountFieldVisible = false;
      this.visibility.schemeVisible = true;
      this.scheme_selected = true;
      this.visibility.schemeVisible = true;
      this.scheme_idd = value.schemeId;
    }
  }

  showHideAcc(value){
    if (value && value.hasOwnProperty('hide_sections') && this.navVar.length > 0) {
      for (let f of this.navVar) {
        if (f.block_id == 'discount' && value.hasOwnProperty('discount_component')) {
          f.show = value.discount_component;
        }
        if (f.block_id == 'deposit' && value.hasOwnProperty('deposite_component')) {
          f.show = value.deposite_component;
        }
        if (f.block_id == 'advance' && value.hasOwnProperty('advance_component')) {
          f.show = value.advance_component;
        }
        if (f.block_id == 'due' && value.hasOwnProperty('due_component')) {
          f.show = value.due_component;
        }
        if (f.block_id == 'remarks' && value.hasOwnProperty('remarks_component')) {
          f.show = value.remarks_component;
        }
        if (f.block_id == 'delivery_charges' && value.hasOwnProperty('charges_component')) {
          f.show = value.charges_component;
        }
        if (f.block_id == 'sponsor' && value.hasOwnProperty('sponsor_component')) {
          f.show = value.sponsor_component;
        }
      }
    }
  }

  checkCreatebill() {
    if (this.config != undefined && this.config.checkCreatebill != undefined) {
      let configdate = moment(this.config.deliveryDate).format("MMM Do YY");
      let currentdate = moment(new Date().getTime()).format("MMM Do YY");
      let batchflag = true;//this.config.items != undefined && this.config.items.length != undefined ? (this.config.items.find(x => !x.batchNo && (x.itemCategory.toLowerCase() != 'coating' || x.itemCategory.toLowerCase() != "glass" || x.itemCategory.toLowerCase() != "contact lens" || x.itemCategory.toLowerCase() != "lens")) ? true : false) : false;
      if (this.config.showDetails) {
        this.showHideAcc(this.config.showDetails);
      }
      if (this.config.items && this.config.items.filter(x => !x.batchNo).length > 0) {
        batchflag = false
      }
  
      return (Math.floor(this.paymentForm.controls['net_receivable_amount'].value) === 0) && (configdate === currentdate) && (batchflag) ? true : false;

    } else { return true }
  }

  getConfigOverridScheme() {
    this.loader.showSpinner()
    if (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD Clinical Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_CLINICAL_BILLING_AUTH_CLEARANCE")){
      this.baseService.get("GET_CONFIG", `config_code:billing_827,module_code:billing`, "facility_config_mapping", "facility-management").subscribe((config: any) => {
        this.loader.hideSpinner();
        if (config.errCode == 0 && config.resource.length > 0 && config.resource[0].config_value == "yes") {
          this.override_config = false;
        }
      })
    }
    else {
      this.baseService.get("GET_CONFIG", `config_code:billing_827,module_code:billing`, "facility_config_mapping", "facility-management").subscribe((config: any) => {
        this.loader.hideSpinner();
        if (config.errCode == 0 && config.resource.length > 0 && config.resource[0].config_value == "yes") {
          this.override_config = true;
        }
      })
    }
  }
  onSponsorAdd(event){
    if (event){
      if (this.amounts.is_discount){
        this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['type'].value, sponsor_fund: this.paymentForm.controls.sponsor_fund.value, 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });

      }else{
        this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['type'].value, sponsor_fund: this.paymentForm.controls.sponsor_fund.value, 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0 });
      }
      
    }

  }
  onSponsorRemove(event){
    if(event.items.length == 0)
  {
  this.paymentForm.controls['sponsor_fund'].value.map(q => q.sanctioned_amount).reduce((acc, curr) => acc + curr, 0)
  this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['used_deposit_amount'].value, sponsor_fund: this.paymentForm.controls.sponsor_fund.value,'sponsor_checked': this.is_sponsor_fund_applied, 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });
  }
    if (this.amounts.is_discount) {
      this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['used_deposit_amount'].value, sponsor_fund: this.paymentForm.controls.sponsor_fund.value,'sponsor_checked': this.is_sponsor_fund_applied, 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value });

    } else {
      this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['used_deposit_amount'].value, sponsor_fund: this.paymentForm.controls.sponsor_fund.value,'sponsor_checked': this.is_sponsor_fund_applied, 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: 0 });
    }
  }
  isSponsorWorkFlowEnable() {
    return new Promise<boolean>((resolve, reject) => {
      this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_843', 'facility_config_mapping', 'facility-management').subscribe(
        result => {
          console.log("res is....." + result)
          if (result.errCode == 0 && result.resource.length > 0) {
            let data = result.resource[0];
            resolve(result.resource[0])
            if (data.config_value == "yes") {
              if (this.dataSet && this.dataSet.transaction_type == "Pharmacy Billing" && (this.dataSet.patient_type == "IP" || (this.dataSet && this.dataSet.op_amount_value && (this.dataSet.op_amount_value.orderedFrom == "IPD PHARMACY SPLIT Order" || this.dataSet.op_amount_value.orderedFrom == "IPD_PHARMACY_SPLIT_BILL_AUTH_CLEARANCE")))) {
                this.isSponsorWorkFlowEnabledFlag = false;
              }
              else {
                this.isSponsorWorkFlowEnabledFlag = true;
              }
            }
          }
        });
    });
  }
  // optionChanged(question) {
  //   if (question.key == "sanctioned_list") {
  //     this.getbillingSponser(this.value_data, this.objval.form.value.sponsor_code, (res) => {
  //       if (res) {
  //         question.options = res
  //       }
  //     })
  //   }
  // }


  optionChanged(question) {
    if (question.key == "sanctioned_list") {
      let obj = {
        projectionKeys: ["sponsor_name", "sponsor_code", "id", "sanctioned_amount", "available_amount", "sanctioned_txn_no", "sanctioned_date_time", "letter_no", "utr_no","topup_id"],
        filter: "sponsor_code:" + this.objval.form.value.sponsor_code + ",is_topup:true,ZeroNotAllowed:true" + ",uhId:" + (this.value_data ? this.value_data.uhId : this.dataSet.uhId),
      }
      if(obj.filter != question?.datasource?.filter){
        question.datasource = {
          "application": "payment",
          "resource": "sponsored_patient_data",
          "query_id": "GET_PATIENT_WISE_DATA",
          "key": "id",
          "filter":obj.filter,
          "projectionKeys":obj.projectionKeys
        }
      }
     
    }
  }

  getbillingSponser(data, sponsor_code, cb) {
    this.loader.showSpinner()
    if (sponsor_code != "") {
      let obj = {
        projectionKeys: ["sponsor_name", "sponsor_code", "id", "sanctioned_amount", "available_amount", "sanctioned_txn_no", "sanctioned_date_time", "letter_no", "utr_no","topup_id","sponsorName"],
        filter: "sponsor_code:" + sponsor_code + ",is_topup:true,ZeroNotAllowed:true" + ",uhId:" + (data ? data.uhId : this.dataSet.uhId),
      }
      this.baseService.getData(obj, '', "sponsored_patient_data", "payment", "GET_PATIENT_WISE_DATA").subscribe((config: any) => {
        if (config.errCode == 0 && config.resource.length > 0) {
          this.loader.hideSpinner()
          cb(config.resource)
        } else {
          cb([])
          this.loader.hideSpinner()
        }
      })
      this.loader.hideSpinner()
    }
    this.loader.hideSpinner();
  }

  addsponsorAmount(value) {
    this.update_fund= [...this.update_fund,(value.map(this.sponsorUpdateFund))]
    if(value[0].sanctioned_amount && this.dataSet.transaction_type != "Pharmacy Billing")
    this.billingSponsorFund.emit([...value])
    setTimeout(() => {
      this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['used_deposit_amount'].value, sponsor_fund: this.update_fund,'sponsor_checked': this.is_sponsor_fund_applied ,'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value,schemeId: this.paymentForm.controls['scheme'].value, discount: this.paymentForm.controls['discount_value'].value ,typeToggled: true });

    }, 1000);
  }
  sponsorUpdateFund(e)
  {
    let newSponsorFund = {
        "topup_id": e.topup_id,
        "db_id":e.db_id,
        "sponsor_code": e.sponsor_code,
        "sanctioned_amount": e.sanctioned_amount,
        "randomupdateId" : e.randomupdateId,
        "sponsor_name":e.sponsor_name,
        "letter_no":e.letter_no,
        "fund_type": e.fund_type,
        "sanctioned_date_time":e.sanctioned_date_time   
  }
    return newSponsorFund; // Return the modified array
  }

  onRemovesponsorItem(value, action) {
    this.resetPaymentDetail();
    if (value != undefined && (action === 'remove'|| action === 'delete') && this.appService.getApplication() == 'pharmacy') {
      let deletevalue = value
      this.calculateAmount(this.paymentForm.controls['net_receivable_amount'].value, '+', deletevalue, this.paymentForm, 'net_receivable_amount', 'final_amount')
    } else {
      if(this.appService.getApplication() == 'pharmacy')
      {
      let deletevalue = value.itemss[value.index].sanctioned_amount
      this.calculateAmount(this.paymentForm.controls['net_receivable_amount'].value, '+', deletevalue, this.paymentForm, 'net_receivable_amount', 'final_amount')
      }

    }
    if(this.baseService._currentTitle=='OP Billing'){
      let data = value.itemss?.map(this.sponsorUpdateFund)
      if(value.itemss[0].sanctioned_amount)
        this.billingSponsorFund.emit({value,action});
      setTimeout(() => {
        this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['used_deposit_amount'].value, sponsor_fund: data,'sponsor_checked': this.is_sponsor_fund_applied ,'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value,schemeId: this.paymentForm.controls['scheme'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value ,typeToggled: true });
      }, 1000);

    }
  }

  updatesponsorAmount(value ,action) {
    let data = value.map(this.sponsorUpdateFund)
    if(value[0].sanctioned_amount)
      this.billingSponsorFund.emit({value,action});
    setTimeout(() => {
      this.serviceDiscount.emit({ deposits: this.paymentForm.controls['deposits'].value, used_deposit_amount: this.paymentForm.controls['used_deposit_amount'].value, sponsor_fund: data,'sponsor_checked': this.is_sponsor_fund_applied ,'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value,schemeId: this.paymentForm.controls['scheme'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, discount: this.paymentForm.controls['discount_value'].value ,typeToggled: true });
    }, 1000);
  }

  calculateAmount(value, action, event, controls, key1, key2) {
    const calculate = (value, action, event) => {
      return action === '-' ? value - event : action === '+' ? value + event : null;
    };
    var finalvalue = calculate(value, action, event)
    controls.controls[key1].setValue(finalvalue)
    controls.controls[key2].setValue(finalvalue)
    this.amounts.netPayableAmount = Number(finalvalue);
  }

  toggleIsSponsorFund(event) {
    if(event=="single_multi_stage" && this.appService.getApplication() == 'pharmacy')
      {
        this.update_fund = [];
        this.is_sponsor_fund_applied = false;
        this.resetSponsorFund(event)
      }
    if (event && event.target && event.target['checked'] != true) {
      this.update_fund = [];
      this.is_sponsor_fund_applied = event.target['checked']
      this.resetSponsorFund(event)
      if(this.appService.getApplication() == 'pharmacy')
      {
      this.paymentForm.controls['final_amount'].setValue((this.paymentForm.controls['final_amount'].value + this.paymentForm.controls['due_amount'].value).toFixed(this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2))
      this.resetDueCheckbox();
      this.resetPaymentDetail();
      this.resetDiscountCheckbox();
      }
    } else {
      if(event && event.target)
      this.is_sponsor_fund_applied = event.target['checked']
    }
  }
  resetSponsorFund(event) {
    let resetSponsorAmount = this.paymentForm.controls['sponsor_fund'].value.map(q => q.sanctioned_amount).reduce((acc, curr) => acc + curr, 0)
    if(event && event == "single_multi_stage" && this.appService.getApplication() == 'pharmacy')
      {
    this.paymentForm.controls['due_amount'].setValue((Number(this.paymentForm.controls['due_amount'].value)+Number(resetSponsorAmount)).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      this.paymentForm.controls['sponsor_fund'].setValue([]);
      this.paymentForm.controls.is_sponsor_fund_applied.setValue(false);
      this.paymentForm.controls['final_amount'].setValue(Number(this.paymentForm.controls['due_amount'].value+this.paymentForm.controls['used_deposit_amount'].value+resetSponsorAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }
    else
    {
    this.paymentForm.controls['sponsor_fund'].setValue(false);
    this.onRemovesponsorItem(resetSponsorAmount, 'remove')
    }
  }
  async showSponsorBlock() {
    const response = await this.isSponsorWorkFlowEnable()
    if (response != undefined && response['config_value'] == "yes" && this.appService.getApplication() == 'payment') {
      const updatedNavVar = this.navVar.map(function (value) {
        if (value.field_name === "Sponsor_billing") {
          value.show = true
          return value
        } else {
          return value;
        }
      });
      this.navVar = updatedNavVar;
    }
    else {
      const updatedNavVar = this.navVar.map(function (value) {
        if (value.field_name === "Sponsor_billing") {
          value.show = false
          return value
        } else {
          return value;
        }
      });
      this.navVar = updatedNavVar;
    }
    this.hideCharitySections();
  }

  // OP billing opened from the charity patient list (?source=charity)
  isCharitySource() {
    return this.activatedRoute?.snapshot?.queryParamMap?.get('source') == 'charity';
  }

  // charity OP order: validity end date drives the automatic expiry, so it is mandatory
  validateCharityValidity() {
    if (!this.isCharitySource()) return true;
    let start = this.paymentForm.controls['charity_validity_start_date'].value;
    let end = this.paymentForm.controls['charity_validity_end_date'].value;
    if (!end) {
      this.alertService.error("Charity validity end date is required");
      return false;
    }
    if (start && end < start) {
      this.alertService.error("Charity validity end date cannot be before the start date");
      return false;
    }
    if (moment(end).endOf('day').valueOf() < Date.now()) {
      this.alertService.error("Charity validity period has already ended");
      return false;
    }
    return true;
  }

  // charity OP order validity pickers: same daterangepicker as validity_start_date / validity_end_date on charity_request_details.json
  charityDateLocale = { format: 'DD/MM/YYYY' };

  charityIncomeTypes = ['Salaried', 'Self-Employed', 'Daily Wage', 'Agriculture', 'Pension', 'Unemployed', 'Other'];

  // charity OP order: same mandatory income fields and patterns as charity_income_details.json
  validateCharityIncome() {
    if (!this.isCharitySource()) return true;
    let income = this.paymentForm?.controls?.['income_details']?.value || {};
    let required = { income_source: 'Income Source', income_certified_by: 'Income Certified By', self_declared_income: 'Self-Declared Income', salary_slip_it_return_income: 'Salary Slip / IT Return Income' };
    let missing = Object.keys(required).find(key => income[key] == null || String(income[key]).trim() === '');
    if (missing) {
      this.alertService.error(required[missing] + " is required");
      return false;
    }
    if (income.ration_card_issue_year != null && income.ration_card_issue_year !== '' && !/^(19|20)\d{2}$/.test(String(income.ration_card_issue_year))) {
      this.alertService.error("Invalid Ration Card Issue Year");
      return false;
    }
    let amounts = ['tehsildar_income', 'self_declared_income', 'ration_card_income', 'salary_slip_it_return_income'];
    if (amounts.some(key => income[key] !== '' && income[key] != null && !/^\d{1,9}(\.\d{1,2})?$/.test(String(income[key])))) {
      this.alertService.error("Invalid income amount entered");
      return false;
    }
    return true;
  }

  // charity billing: only the billing summary, discount, income details and upload document sections apply
  hideCharitySections() {
    if (!this.isCharitySource()) return;
    let hidden = ['deposit', 'sponsor', 'Sponsor_billing', 'advance', 'payment_details', 'due', 'delivery_charges', 'remarks'];
    this.navVar.forEach(section => {
      if (hidden.includes(section.block_id)) section.show = false;
      if (section.block_id == 'income_details' || section.block_id == 'upload_document') section.show = true;
    });
    this.showDeposit = false;
  }
  showdata(event){
    let obj = this.mainOBj;
    let patientAmount = this.paymentForm.controls['final_amount'].value;
    console.log("data is ",obj);
    if(event == "added"){
      if(this.dataSet && this.dataSet !=undefined &&  this.dataSet.transaction_type !=undefined && this.dataSet.transaction_type == "optical billing"){
         if(patientAmount && this.paymentForm.controls['is_default_amount'].value){
        this.amounts.netPayableAmount = (patientAmount - this.paymentForm.controls['is_default_amount'].value);
        this.amounts.netPayableAmount = Math.abs(this.amounts.netPayableAmount);
      if(!this.optical_billing_advance){
       // this.paymentForm.controls['is_default_amount'].setValue(0);
        this.paymentForm.controls['net_receivable_amount'].setValue(Number(this.amounts.netPayableAmount).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
      }else{
        this.paymentForm.controls['final_amount'].setValue(this.amounts.netPayableAmount);
        this.paymentForm.controls['net_receivable_amount'].setValue(this.amounts.netPayableAmount);
      } 
        //obj.form.controls['net_receivable_amount'].updateValueAndValidity();
        obj.form.controls['received_amount'].setValue( this.amounts.netPayableAmount)
        obj.form.controls['received_amount'].updateValueAndValidity();
      }
    }
    }else if(event == "removed"){
      this.resetPaymentDetail();
      obj.form.controls['received_amount'].setValue(patientAmount)
      obj.form.controls['received_amount'].updateValueAndValidity();
    }else if(event == "fill_amount" && this.dataSet.final_amount && !this.firstTimeFilled){
      if (obj.form.controls['received_amount']) {
        this.changeDueAmountDecimal = true;
        if(this.dataSet.final_amount){
          obj.form.controls['received_amount'].setValue(this.dataSet.final_amount.toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2));
          this.firstTimeFilled = true;
        }else{

        }
      }
    }
   
}
}